/**
 * Milano & Co. theme interactions
 * Drawers, mega-menu secondary, card gallery, installments, wishlist,
 * shared cart permalinks, benefits coupon apply
 */
(function () {
  'use strict';

  var WISHLIST_KEY = 'mco_wishlist';
  var BENEFITS_KEY = 'mco_benefits_lead';
  var COUPON_CODE = 'milano10';

  function readBenefitsLead() {
    var raw = '';
    try {
      raw = localStorage.getItem(BENEFITS_KEY) || sessionStorage.getItem(BENEFITS_KEY) || '';
    } catch (err) {
      try {
        raw = sessionStorage.getItem(BENEFITS_KEY) || '';
      } catch (err2) {}
    }
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err3) {
      return null;
    }
  }

  function writeBenefitsLead(payload) {
    var raw = JSON.stringify(payload || {});
    try {
      localStorage.setItem(BENEFITS_KEY, raw);
    } catch (err) {}
    try {
      sessionStorage.setItem(BENEFITS_KEY, raw);
    } catch (err2) {}
  }

  function benefitsFirstName(lead) {
    var name = ((lead && lead.name) || '').trim();
    if (!name) return '';
    return name.split(/\s+/)[0];
  }

  function isMilanoBusinessHours(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Sao_Paulo',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(date || new Date());
    var map = {};
    parts.forEach(function (p) {
      if (p.type !== 'literal') map[p.type] = p.value;
    });
    var weekday = (map.weekday || '').toLowerCase();
    var hour = parseInt(map.hour, 10);
    var minute = parseInt(map.minute, 10);
    var mins = hour * 60 + minute;
    var isWeekday = ['mon', 'tue', 'wed', 'thu', 'fri'].indexOf(weekday) !== -1;
    return isWeekday && mins >= 10 * 60 && mins < 18 * 60;
  }

  /* Fees from WC functions.php — interest-free through 6x; 7–12 use % fee on total */
  var INSTALLMENT_FEES = {
    7: 15.34,
    8: 16.59,
    9: 17.84,
    10: 19.09,
    11: 20.34,
    12: 21.59,
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function formatBRL(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  /* Ensure overlay + drawers escape Shopify header-group stacking */
  function ensureDrawerOverlay() {
    var overlay = document.getElementById('mco-drawer-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'mco-drawer-overlay';
      overlay.className = 'mco-drawer-overlay';
      overlay.setAttribute('data-mco-drawer-close', '');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    } else if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    /* Kill duplicate overlays that may remain inside sections */
    qsa('.mco-drawer-overlay').forEach(function (el) {
      if (el !== overlay) el.remove();
    });
    return overlay;
  }

  function moveDrawerChromeToBody() {
    var overlay = ensureDrawerOverlay();
    var ids = [
      'mco-menu-drawer',
      'mco-menu-secondary-femininos',
      'mco-menu-secondary-masculinos',
      'mco-account-drawer',
      'mco-cart-drawer-milano',
    ];
    /* Append overlay first, then drawers, so drawers stack above */
    document.body.appendChild(overlay);
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) document.body.appendChild(el);
    });
  }

  function moveModalsToBody() {
    qsa('.mco-modal').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function setOverlayOpen(isOpen) {
    var overlay = ensureDrawerOverlay();
    overlay.classList.toggle('is-open', !!isOpen);
    overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) {
      overlay.style.setProperty('opacity', '1', 'important');
      overlay.style.setProperty('visibility', 'visible', 'important');
      overlay.style.setProperty('pointer-events', 'auto', 'important');
      overlay.style.setProperty('display', 'block', 'important');
    } else {
      overlay.style.setProperty('opacity', '0', 'important');
      overlay.style.setProperty('visibility', 'hidden', 'important');
      overlay.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function openDrawer(id) {
    moveDrawerChromeToBody();
    var drawer = qs('#' + id);
    if (!drawer) return;
    qsa('.mco-drawer.is-open, .mco-menu-secondary.is-open').forEach(function (d) {
      if (d.id === id) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    drawer.setAttribute('aria-hidden', 'false');
    var isCartMobile =
      id === 'mco-cart-drawer-milano' && window.matchMedia('(max-width: 989px)').matches;
    setOverlayOpen(!isCartMobile);
    document.documentElement.classList.add('mco-drawer-open');
    document.documentElement.classList.toggle('mco-cart-drawer-open', id === 'mco-cart-drawer-milano');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    });
  }

  function closeDrawers() {
    qsa('.mco-drawer.is-open, .mco-menu-secondary.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    setOverlayOpen(false);
    document.documentElement.classList.remove('mco-drawer-open');
    document.documentElement.classList.remove('mco-cart-drawer-open');
    document.body.style.overflow = '';
    var localePanel = qs('#mco-menu-locale');
    var localeToggle = qs('[data-mco-locale-toggle]');
    if (localePanel) localePanel.hidden = true;
    if (localeToggle) localeToggle.setAttribute('aria-expanded', 'false');
    var menuSearchInput = qs('[data-mco-menu-search-input]');
    var menuSearchResults = qs('[data-mco-menu-search-results]');
    var menuSearchClear = qs('[data-mco-menu-search-clear]');
    var menuSearchDropdown = qs('[data-mco-menu-search-dropdown]');
    if (menuSearchInput) {
      menuSearchInput.value = '';
      menuSearchInput.setAttribute('aria-expanded', 'false');
    }
    if (menuSearchClear) menuSearchClear.hidden = true;
    if (menuSearchResults) menuSearchResults.innerHTML = '';
    if (menuSearchDropdown) {
      menuSearchDropdown.hidden = true;
      menuSearchDropdown.setAttribute('aria-hidden', 'true');
    }
  }

  function openModal(id) {
    moveModalsToBody();
    var modal = qs('#' + id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mco-modal-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    if (
      (modal.id === 'mco-benefits-modal' || modal.id === 'mco-review-success-modal') &&
      typeof stopBenefitsConfetti === 'function'
    ) {
      stopBenefitsConfetti();
    }
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!qs('.mco-modal.is-open')) {
      document.documentElement.classList.remove('mco-modal-open');
      if (!document.documentElement.classList.contains('mco-drawer-open')) {
        document.body.style.overflow = '';
      }
    }
  }

  function openSecondaryMenu(which) {
    moveDrawerChromeToBody();
    var primary = qs('#mco-menu-drawer');
    var panelId =
      which === 'masculinos' ? 'mco-menu-secondary-masculinos' : 'mco-menu-secondary-femininos';
    var secondary = qs('#' + panelId);
    if (!secondary) return;
    qsa('[data-mco-menu-category]').forEach(function (panel) {
      if (panel === secondary) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    if (primary) {
      primary.classList.add('is-open');
      primary.setAttribute('aria-hidden', 'false');
    }
    secondary.classList.add('is-open');
    secondary.setAttribute('aria-hidden', 'false');
    setOverlayOpen(true);
    document.documentElement.classList.add('mco-drawer-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSecondaryMenu() {
    qsa('[data-mco-menu-category]').forEach(function (secondary) {
      secondary.classList.remove('is-open');
      secondary.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---- Click routing ---- */
  document.addEventListener(
    'click',
    function (e) {
      var overlay = qs('#mco-drawer-overlay');
      var clickedOverlay = overlay && (e.target === overlay || e.target.id === 'mco-drawer-overlay');
      var clickedClose = e.target.closest('[data-mco-drawer-close]');

      if (clickedOverlay || clickedClose) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawers();
        return;
      }

      /* Click outside any open drawer (fallback if overlay missed the hit) */
      if (document.documentElement.classList.contains('mco-drawer-open')) {
        var openDrawerEl = qs('.mco-drawer.is-open, .mco-menu-secondary.is-open');
        if (
          openDrawerEl &&
          !e.target.closest('.mco-drawer.is-open') &&
          !e.target.closest('.mco-menu-secondary.is-open') &&
          !e.target.closest('[data-mco-drawer]') &&
          !e.target.closest('.mco-modal')
        ) {
          e.preventDefault();
          closeDrawers();
          return;
        }
      }
    },
    true
  );

  document.addEventListener('click', function (e) {
    /* Close drawers when clicking the dimmed overlay or any close control — handled in capture above */

    var localeToggle = e.target.closest('[data-mco-locale-toggle]');
    if (localeToggle) {
      e.preventDefault();
      var panel = qs('#mco-menu-locale');
      if (panel) {
        var open = panel.hidden;
        panel.hidden = !open;
        localeToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var secondaryOpen = e.target.closest('[data-mco-secondary-open]');
    if (secondaryOpen) {
      e.preventDefault();
      openSecondaryMenu(secondaryOpen.getAttribute('data-mco-secondary-open'));
      return;
    }
    if (e.target.closest('[data-mco-secondary-back]')) {
      e.preventDefault();
      closeSecondaryMenu();
      return;
    }

    var carouselPrev = e.target.closest('[data-mco-carousel-prev]');
    if (carouselPrev) {
      e.preventDefault();
      scrollCarousel(carouselPrev.getAttribute('data-mco-carousel-prev'), -1);
      return;
    }
    var carouselNext = e.target.closest('[data-mco-carousel-next]');
    if (carouselNext) {
      e.preventDefault();
      scrollCarousel(carouselNext.getAttribute('data-mco-carousel-next'), 1);
      return;
    }

    var t = e.target.closest('[data-mco-drawer]');
    if (t) {
      e.preventDefault();
      var drawerId = t.getAttribute('data-mco-drawer');
      openDrawer(drawerId);
      if (drawerId === 'mco-cart-drawer-milano' && typeof refreshCartDrawer === 'function') {
        refreshCartDrawer();
      }
      return;
    }

    var modalOpen = e.target.closest('[data-mco-modal]');
    if (modalOpen) {
      e.preventDefault();
      var modalId = modalOpen.getAttribute('data-mco-modal');
      if (modalId === 'mco-installment-modal') {
        var cents = modalOpen.getAttribute('data-mco-installment-cents');
        var price = cents ? parseInt(cents, 10) / 100 : getInstallmentBasePrice();
        renderInstallmentTable(price);
        openModal(modalId);
        requestAnimationFrame(function () {
          updateInstallmentScrollCue();
          setTimeout(updateInstallmentScrollCue, 50);
        });
        return;
      }
      if (modalId === 'mco-benefits-modal' && readBenefitsLead()) {
        return;
      }
      openModal(modalId);
      if (modalId === 'mco-benefits-modal' && typeof showBenefitsStep === 'function') {
        showBenefitsStep(1);
        if (typeof loadBenefitsConfetti === 'function') loadBenefitsConfetti(function () {});
      }
      if (modalId === 'mco-concierge-modal') {
        var conciergeModal = qs('#mco-concierge-modal');
        if (conciergeModal && typeof conciergeModal._mcoRefreshStatus === 'function') {
          conciergeModal._mcoRefreshStatus();
        }
      }
      if (modalId === 'mco-samara-modal') {
        prepareSamaraModal();
      }
      return;
    }
    if (e.target.closest('[data-mco-modal-close]')) {
      closeModal(e.target.closest('.mco-modal'));
      return;
    }
    if (e.target.classList.contains('mco-modal__backdrop')) {
      closeModal(e.target.closest('.mco-modal'));
      return;
    }
    if (e.target.classList.contains('mco-modal') && e.target.classList.contains('is-open')) {
      closeModal(e.target);
      return;
    }

    var wishBtn = e.target.closest('[data-mco-wishlist]');
    if (wishBtn) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(wishBtn);
      return;
    }

    var relatedAtc = e.target.closest('[data-mco-card-atc]');
    if (relatedAtc) {
      e.preventDefault();
      e.stopPropagation();
      addRelatedCardToCart(relatedAtc);
      return;
    }

    var dot = e.target.closest('.mco-card__dot');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      var card = dot.closest('.mco-card');
      goToCardSlide(card, parseInt(dot.getAttribute('data-index'), 10));
      return;
    }

    if (e.target.closest('[data-mco-share-cart]') || e.target.id === 'mco-share-cart') {
      e.preventDefault();
      shareCart();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openModalEl = qs('.mco-modal.is-open');
      if (openModalEl) {
        closeModal(openModalEl);
        return;
      }
      closeSecondaryMenu();
      closeDrawers();
    }
  });

  function scrollCarousel(id, dir) {
    var el = qs('#' + id);
    if (!el) return;
    el.scrollBy({ left: dir * Math.max(220, el.clientWidth * 0.7), behavior: 'smooth' });
  }

  /* ---- Card mini-gallery ---- */
  function goToCardSlide(card, index) {
    if (!card) return;
    var slides = qsa('.mco-card__slide, .novidades-card-slide', card);
    var dots = qsa('.mco-card__dot, .novidades-card-dot', card);
    var priceLayers = qsa('.mco-card__price-layer', card);
    var priceIndex = index === 0 ? 0 : 1;
    slides.forEach(function (s, i) {
      var on = i === index;
      s.classList.toggle('is-active', on);
      s.style.opacity = on ? '1' : '0';
      s.style.pointerEvents = on ? 'auto' : 'none';
    });
    dots.forEach(function (d, i) {
      var on = i === index;
      d.classList.toggle('is-active', on);
      d.classList.toggle('active', on);
    });
    priceLayers.forEach(function (layer, i) {
      var on = i === priceIndex;
      layer.classList.toggle('is-active', on);
      layer.style.opacity = on ? '1' : '0';
    });
    var gallery = qs('.mco-card__gallery, .novidades-card-gallery', card);
    if (gallery) gallery.setAttribute('data-current', String(index));
  }

  /* Shared clock so every card shows image 0 → 1 → 0 in lockstep (with price text). */
  var CARD_SLIDESHOW_MS = 5000;
  var cardSlideshowEpoch = Date.now();
  var cardSlideshowTimer = null;
  var cardSlideshowLastIndex = -1;

  function getGlobalCardSlideIndex() {
    return Math.floor((Date.now() - cardSlideshowEpoch) / CARD_SLIDESHOW_MS) % 2;
  }

  function syncAllCardSlides(force) {
    var index = getGlobalCardSlideIndex();
    if (!force && index === cardSlideshowLastIndex) return;
    cardSlideshowLastIndex = index;
    qsa('.mco-card[data-novidades-slideshow="1"]').forEach(function (card) {
      var slides = qsa('.mco-card__slide, .novidades-card-slide', card);
      if (slides.length < 2) return;
      goToCardSlide(card, index % slides.length);
    });
  }

  function initCardAutoplay(root) {
    var scope = root && root.querySelectorAll ? root : document;
    qsa('.mco-card[data-novidades-slideshow="1"]', scope).forEach(function (card) {
      card.setAttribute('data-mco-slideshow-init', '1');
    });
    syncAllCardSlides(true);
    if (window.__mcoCardSlideshowIoReady) {
      if (typeof window.__mcoObserveCardSlideshow === 'function') window.__mcoObserveCardSlideshow();
      return;
    }
    window.__mcoCardSlideshowIoReady = true;

    var visible = Object.create(null);
    function visibleCount() {
      return Object.keys(visible).length;
    }
    function ensureTimer() {
      if (visibleCount() > 0 && !document.hidden) {
        if (!cardSlideshowTimer) {
          cardSlideshowTimer = setInterval(function () {
            syncAllCardSlides(false);
          }, 1000);
        }
      } else if (cardSlideshowTimer) {
        clearInterval(cardSlideshowTimer);
        cardSlideshowTimer = null;
      }
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var id = entry.target.getAttribute('data-product-id') || entry.target.getAttribute('data-product-handle') || String(Math.random());
            if (!entry.target.__mcoObsId) entry.target.__mcoObsId = id + '-' + Math.random().toString(36).slice(2, 7);
            if (entry.isIntersecting) visible[entry.target.__mcoObsId] = true;
            else delete visible[entry.target.__mcoObsId];
          });
          ensureTimer();
        },
        { rootMargin: '80px', threshold: 0.05 }
      );
      function observeAll() {
        qsa('.mco-card[data-novidades-slideshow="1"]').forEach(function (card) {
          io.observe(card);
        });
      }
      observeAll();
      window.__mcoObserveCardSlideshow = observeAll;
    } else {
      visible.fallback = true;
      ensureTimer();
    }

    document.addEventListener('visibilitychange', ensureTimer);
  }

  function initCardSwipe(card) {
    if (!card || card.getAttribute('data-mco-card-swipe-init') === '1') return;
    var gallery = qs('.mco-card__gallery, .novidades-card-gallery', card);
    if (!gallery) return;
    var slides = qsa('.mco-card__slide, .novidades-card-slide', card);
    if (slides.length < 2) return;

    card.setAttribute('data-mco-card-swipe-init', '1');

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var threshold = 40;
    var mobileMq = window.matchMedia('(max-width: 989px)');

    function handleSwipe(dx, dy) {
      if (!mobileMq.matches) return;
      if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;
      var current = parseInt(gallery.getAttribute('data-current') || '0', 10);
      var next = dx < 0 ? current + 1 : current - 1;
      goToCardSlide(card, ((next % slides.length) + slides.length) % slides.length);
    }

    gallery.addEventListener(
      'touchstart',
      function (e) {
        if (!mobileMq.matches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (!e.changedTouches.length) return;
        handleSwipe(e.changedTouches[0].clientX - startX, e.changedTouches[0].clientY - startY);
      },
      { passive: true }
    );

    gallery.addEventListener(
      'touchcancel',
      function () {
        tracking = false;
      },
      { passive: true }
    );
  }

  function initCardNav(card) {
    if (!card || card.getAttribute('data-mco-card-nav-init') === '1') return;
    var navBtns = qsa('[data-mco-card-nav]', card);
    if (!navBtns.length) return;
    var gallery = qs('.mco-card__gallery, .novidades-card-gallery', card);
    var slides = qsa('.mco-card__slide, .novidades-card-slide', card);
    if (!gallery || slides.length < 2) return;

    card.setAttribute('data-mco-card-nav-init', '1');
    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dir = parseInt(btn.getAttribute('data-mco-card-nav') || '0', 10);
        if (!dir) return;
        var current = parseInt(gallery.getAttribute('data-current') || '0', 10);
        var next = current + dir;
        goToCardSlide(card, ((next % slides.length) + slides.length) % slides.length);
      });
    });
  }

  function initCardSwipeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    qsa('.mco-card[data-novidades-slideshow="1"]', scope).forEach(function (card) {
      initCardSwipe(card);
      initCardNav(card);
    });
  }

  function initCardSlideshow(root) {
    initCardAutoplay(root);
    initCardSwipeAll(root);
    initProductImageLoaders(root);
  }

  function initProductImageLoaders(root) {
    var scope = root && root.querySelectorAll ? root : document;
    qsa('.mco-image-loader', scope).forEach(function (loader) {
      if (loader.getAttribute('data-mco-loader-init') === '1') return;
      loader.setAttribute('data-mco-loader-init', '1');

      var image = qs('img', loader.parentElement);
      if (!image) {
        loader.classList.add('is-hidden');
        return;
      }

      function hideLoader() {
        loader.classList.add('is-hidden');
      }

      if (image.complete) {
        hideLoader();
      } else {
        image.addEventListener('load', hideLoader, { once: true });
        image.addEventListener('error', hideLoader, { once: true });
      }
    });
  }

  function initRelatedProductsSlideshow() {
    qsa('product-recommendations').forEach(function (el) {
      if (el.getAttribute('data-mco-rec-init') === '1') return;
      el.setAttribute('data-mco-rec-init', '1');
      var observer = new MutationObserver(function () {
        if (!el.querySelector('.search-product-card, .mco-card')) return;
        initCardSlideshow(el);
        /* One-shot: avoid re-entry when filters reorder cards via appendChild */
        observer.disconnect();
      });
      observer.observe(el, { childList: true, subtree: false });
      initCardSlideshow(el);
    });
  }

  /* ---- Installments ---- */
  function getInstallmentBasePrice() {
    var table = qs('#mco-installment-table-body');
    var fromAttr = table && table.getAttribute('data-mco-price');
    if (fromAttr && parseFloat(fromAttr) > 0) return parseFloat(fromAttr);
    var pdp = qs('[data-mco-installment-cents]');
    if (pdp) return parseInt(pdp.getAttribute('data-mco-installment-cents'), 10) / 100;
    return 0;
  }

  function renderInstallmentTable(priceBRL) {
    var body = qs('#mco-installment-table-body');
    if (!body || !priceBRL || priceBRL <= 0) return;
    body.setAttribute('data-mco-price', String(priceBRL));
    body.innerHTML = '';
    for (var i = 1; i <= 12; i++) {
      var totalRow;
      var parcela;
      if (i <= 6) {
        totalRow = priceBRL;
        parcela = priceBRL / i;
      } else {
        var fee = INSTALLMENT_FEES[i] || 0;
        totalRow = priceBRL * (1 + fee / 100);
        parcela = totalRow / i;
      }
      var row = document.createElement('div');
      row.className = 'mco-installment-table-row';
      row.innerHTML =
        '<div>' +
        i +
        'x</div><div>' +
        formatBRL(parcela) +
        '</div><div>' +
        formatBRL(totalRow) +
        '</div>';
      body.appendChild(row);
    }
    updateInstallmentScrollCue();
  }

  function updateInstallmentScrollCue() {
    var modal = qs('#mco-installment-modal');
    if (!modal) return;
    var shell = qs('.mco-installment-table-shell', modal);
    var scroller = qs('[data-mco-installment-scroll]', modal);
    var moreBtn = qs('[data-mco-installment-scroll-more]', modal);
    if (!shell || !scroller || !moreBtn) return;

    var canScroll = scroller.scrollHeight > scroller.clientHeight + 2;
    var nearBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 32;
    var show = canScroll && !nearBottom;

    shell.classList.toggle('has-more', show);
    if (show) {
      moreBtn.hidden = false;
      moreBtn.removeAttribute('hidden');
    } else {
      moreBtn.hidden = true;
      moreBtn.setAttribute('hidden', '');
    }
  }

  function initInstallmentScrollCue() {
    var modal = qs('#mco-installment-modal');
    if (!modal || modal.getAttribute('data-mco-installment-scroll-ready') === '1') return;
    modal.setAttribute('data-mco-installment-scroll-ready', '1');

    var scroller = qs('[data-mco-installment-scroll]', modal);
    var moreBtn = qs('[data-mco-installment-scroll-more]', modal);
    if (!scroller || !moreBtn) return;

    scroller.addEventListener(
      'scroll',
      function () {
        updateInstallmentScrollCue();
      },
      { passive: true }
    );

    moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var step = Math.max(120, Math.floor(scroller.clientHeight * 0.85));
      var remaining = scroller.scrollHeight - (scroller.scrollTop + scroller.clientHeight);
      var target = remaining <= step + 24 ? scroller.scrollHeight : scroller.scrollTop + step;
      if (typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ top: target, behavior: 'smooth' });
      } else {
        scroller.scrollTop = target;
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        updateInstallmentScrollCue();
      });
      ro.observe(scroller);
    }

    window.addEventListener('resize', function () {
      updateInstallmentScrollCue();
    });
  }

  initInstallmentScrollCue();

  /* ---- Wishlist (localStorage) ---- */
  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }

  function paintWishlistButton(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (btn.hasAttribute('data-mco-wishlist-icon')) return;
    btn.textContent = on ? '♥' : '♡';
  }

  function toggleWishlist(btn) {
    var id = btn.getAttribute('data-product-id');
    var items = readWishlist();
    var idx = items.findIndex(function (x) {
      return String(x.id) === String(id);
    });
    if (idx >= 0) {
      items.splice(idx, 1);
    } else {
      items.push({
        id: id,
        handle: btn.getAttribute('data-product-handle'),
        url: btn.getAttribute('data-product-url'),
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
      });
    }
    writeWishlist(items);
    syncWishlistUI();
  }

  function syncWishlistUI() {
    var ids = readWishlist().map(function (x) {
      return String(x.id);
    });
    qsa('[data-mco-wishlist]').forEach(function (btn) {
      paintWishlistButton(btn, ids.indexOf(String(btn.getAttribute('data-product-id'))) !== -1);
    });
  }

  /* ---- Shared cart (Shopify permalink) ---- */
  function shareCart() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          alert('Seu carrinho está vazio.');
          return;
        }
        var parts = cart.items.map(function (item) {
          return item.variant_id + ':' + item.quantity;
        });
        var url = window.location.origin + '/cart/' + parts.join(',');
        try {
          var discount = sessionStorage.getItem('mco_coupon');
          if (discount) url += '?discount=' + encodeURIComponent(discount);
        } catch (e) {}
        var input = qs('#mco-share-cart-url');
        if (input) input.value = url;
        openModal('mco-share-cart-modal');
      })
      .catch(function () {
        alert('Não foi possível gerar o link do carrinho.');
      });
  }

  var copyBtn = qs('#mco-share-cart-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var input = qs('#mco-share-cart-url');
      if (!input || !input.value) return;
      navigator.clipboard.writeText(input.value).then(function () {
        var status = qs('#mco-share-cart-status');
        if (status) status.textContent = 'Link copiado!';
      });
    });
  }

  /* ---- Benefits + coupon ---- */
  var benefitsStep = 1;
  function showBenefitsStep(n) {
    benefitsStep = n;
    qsa('#mco-benefits-modal [data-benefits-step]').forEach(function (el) {
      el.hidden = parseInt(el.getAttribute('data-benefits-step'), 10) !== n;
    });
  }

  function formatBrWhatsapp(value) {
    var digits = brWhatsappDigits(value);
    if (digits.length <= 2) return digits.length ? '(' + digits : '';
    if (digits.length <= 6) return '(' + digits.slice(0, 2) + ') ' + digits.slice(2);
    if (digits.length <= 10) {
      return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 6) + '-' + digits.slice(6);
    }
    return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + '-' + digits.slice(7);
  }

  function brWhatsappDigits(value) {
    var digits = String(value || '').replace(/\D/g, '');
    /* Strip country code only when pasted as +55 / 55 + full local number */
    if (digits.length > 11 && digits.indexOf('55') === 0) {
      digits = digits.slice(2);
    }
    return digits.slice(0, 11);
  }

  var benefitsWaInput = qs('#mco-benefits-wa');
  if (benefitsWaInput) {
    benefitsWaInput.addEventListener('input', function () {
      var formatted = formatBrWhatsapp(benefitsWaInput.value);
      benefitsWaInput.value = formatted;
    });
    benefitsWaInput.addEventListener('blur', function () {
      benefitsWaInput.value = formatBrWhatsapp(benefitsWaInput.value);
    });
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function normalizeDiscountCode(code) {
    return String(code || '')
      .trim()
      .toLowerCase();
  }

  function cartHasApplicableDiscount(cart, code) {
    if (!cart) return false;
    var target = normalizeDiscountCode(code);
    if (!target) return false;
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      var entry = codes[i];
      if (!entry) continue;
      if (normalizeDiscountCode(entry.code) === target && entry.applicable !== false) {
        return true;
      }
    }
    var apps = cart.cart_level_discount_applications || [];
    for (var j = 0; j < apps.length; j++) {
      var app = apps[j];
      if (!app) continue;
      var title = normalizeDiscountCode(app.title || app.code || '');
      if (title && title === target) return true;
    }
    return false;
  }

  function cartHasNoDiscounts(cart) {
    if (!cart) return false;
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].code && codes[i].applicable !== false) return false;
    }
    return true;
  }

  function fetchCartJson() {
    return fetch(shopifyRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      if (!r.ok) throw new Error('cart fetch failed');
      return r.json();
    });
  }

  /* Apply/clear discount via Cart AJAX (/cart/update.js discount param). Never navigates. */
  function applyCoupon(code) {
    var normalized = String(code || '').trim();
    var root = shopifyRoot();

    function applyViaDiscountPath() {
      return fetch(root + 'discount/' + encodeURIComponent(normalized), {
        credentials: 'same-origin',
        redirect: 'manual',
      }).then(function () {
        return fetchCartJson();
      });
    }

    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: normalized }),
    })
      .then(function (r) {
        if (r.ok) return r.json();
        if (!normalized) throw new Error('remove coupon failed');
        return applyViaDiscountPath();
      })
      .then(function (cart) {
        if (!cart) throw new Error(normalized ? 'apply coupon failed' : 'remove coupon failed');
        if (!normalized) {
          if (!cartHasNoDiscounts(cart)) throw new Error('remove coupon failed');
          return cart;
        }
        if (cartHasApplicableDiscount(cart, normalized)) return cart;
        /* update.js may ignore discount on some setups — try cookie path in-place */
        return applyViaDiscountPath().then(function (cart2) {
          if (!cartHasApplicableDiscount(cart2, normalized)) {
            throw new Error('invalid coupon');
          }
          return cart2;
        });
      });
  }

  function removeCartCoupon() {
    return applyCoupon('').then(function (cart) {
      try {
        sessionStorage.removeItem('mco_coupon');
      } catch (err) {}
      return cart;
    });
  }

  function applyCartCouponCode(code) {
    var normalized = String(code || '').trim();
    return applyCoupon(normalized).then(function (cart) {
      try {
        sessionStorage.setItem('mco_coupon', normalized);
      } catch (err) {}
      return cart;
    });
  }

  var ESQUENTA_GIFT_HANDLE = 'gift-bag';
  var esquentaChain = Promise.resolve();

  function watchQuantity(cart) {
    var total = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item) continue;
      var handle = String(item.handle || '');
      if (!handle && item.url) {
        var match = String(item.url).match(/\/products\/([^/?#]+)/);
        handle = match ? decodeURIComponent(match[1]) : '';
      }
      if (handle === ESQUENTA_GIFT_HANDLE) continue;
      total += Number(item.quantity) || 0;
    }
    return total;
  }

  function currentDiscountCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].code && codes[i].applicable !== false) return String(codes[i].code);
    }
    return '';
  }

  function desiredEsquentaCode(qty) {
    if (qty === 1) return 'ESQUENTA10';
    if (qty >= 2) return 'ESQUENTA30';
    return '';
  }

  /* One watch: 10% off. Two or more: 30% off the cheaper item in each pair. Gift bag is ignored. */
  function syncEsquentaDiscount() {
    esquentaChain = esquentaChain
      .catch(function () {})
      .then(function () {
        return fetchCartJson().then(function (cart) {
          var desired = desiredEsquentaCode(watchQuantity(cart));
          var current = currentDiscountCode(cart);
          var currentNorm = normalizeDiscountCode(current);
          if (desired) {
            if (currentNorm === normalizeDiscountCode(desired)) return cart;
            return applyCoupon(desired).then(function (next) {
              try {
                sessionStorage.setItem('mco_coupon', desired);
              } catch (err) {}
              return next;
            });
          }
          if (currentNorm === 'esquenta10' || currentNorm === 'esquenta30') {
            return applyCoupon('').then(function (next) {
              try {
                sessionStorage.removeItem('mco_coupon');
              } catch (err2) {}
              return next;
            });
          }
          return cart;
        });
      });
    return esquentaChain;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function toE164BrWhatsapp(digits) {
    var d = String(digits || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.indexOf('55') === 0 && d.length >= 12) return '+' + d;
    return '+55' + d;
  }

  function setBenefitsSubmitting(isSubmitting) {
    var btn = qs('#mco-benefits-submit');
    var form = qs('#mco-benefits-form');
    if (btn) {
      btn.disabled = !!isSubmitting;
      btn.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      btn.textContent = isSubmitting ? 'Ativando...' : 'Ativar Benefícios';
    }
    if (form) {
      form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }
  }

  function showBenefitsError(message) {
    var err = qs('#mco-benefits-error');
    if (!err) return;
    err.hidden = !message;
    err.textContent = message || '';
  }

  function loadBenefitsConfetti(callback) {
    if (typeof window.confetti === 'function') {
      callback();
      return;
    }
    var existing = document.querySelector('script[data-mco-confetti]');
    if (existing) {
      if (existing.getAttribute('data-mco-confetti-ready') === '1') {
        callback();
        return;
      }
      existing.addEventListener('load', callback, { once: true });
      existing.addEventListener('error', callback, { once: true });
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.4/dist/confetti.browser.min.js';
    script.async = true;
    script.setAttribute('data-mco-confetti', '1');
    script.addEventListener(
      'load',
      function () {
        script.setAttribute('data-mco-confetti-ready', '1');
        callback();
      },
      { once: true }
    );
    script.addEventListener('error', callback, { once: true });
    document.head.appendChild(script);
  }

  var benefitsConfettiActive = false;
  var benefitsConfettiTimer = null;
  var benefitsConfettiRaf = 0;

  function stopBenefitsConfetti() {
    benefitsConfettiActive = false;
    if (benefitsConfettiTimer) {
      window.clearInterval(benefitsConfettiTimer);
      benefitsConfettiTimer = null;
    }
    if (benefitsConfettiRaf) {
      window.cancelAnimationFrame(benefitsConfettiRaf);
      benefitsConfettiRaf = 0;
    }
    qsa('[data-mco-confetti-canvas]').forEach(function (canvas) {
      canvas.remove();
    });
  }

  function fireBenefitsConfettiFallback() {
    stopBenefitsConfetti();
    benefitsConfettiActive = true;
    var canvas = document.createElement('canvas');
    canvas.setAttribute('data-mco-confetti-canvas', '1');
    canvas.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    if (!ctx) {
      canvas.remove();
      return;
    }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = window.innerWidth;
    var h = window.innerHeight;
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.scale(dpr, dpr);
    var colors = ['#D4AF37', '#F5D76E', '#C9A227', '#FFEAA7', '#B8860B', '#E8C547'];
    var pieces = [];

    function spawnPiece() {
      return {
        x: Math.random() * w,
        y: -20 - Math.random() * 40,
        r: 3 + Math.random() * 5,
        vy: 2.2 + Math.random() * 3.4,
        vx: -1.2 + Math.random() * 2.4,
        rot: Math.random() * Math.PI,
        vr: -0.12 + Math.random() * 0.24,
        color: colors[Math.floor(Math.random() * colors.length)],
      };
    }

    for (var i = 0; i < 120; i++) {
      pieces.push(spawnPiece());
      pieces[i].y = -20 - Math.random() * h * 0.5;
    }

    function frame() {
      if (!benefitsConfettiActive) {
        canvas.remove();
        benefitsConfettiRaf = 0;
        return;
      }
      ctx.clearRect(0, 0, w, h);
      pieces.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        if (p.y > h + 24) {
          p.x = Math.random() * w;
          p.y = -20 - Math.random() * 40;
          p.vy = 2.2 + Math.random() * 3.4;
          p.vx = -1.2 + Math.random() * 2.4;
        }
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.r, -p.r * 0.4, p.r * 2, p.r * 0.8);
        ctx.restore();
      });
      benefitsConfettiRaf = requestAnimationFrame(frame);
    }
    benefitsConfettiRaf = requestAnimationFrame(frame);
  }

  function fireBenefitsConfetti() {
    stopBenefitsConfetti();
    benefitsConfettiActive = true;
    loadBenefitsConfetti(function () {
      if (!benefitsConfettiActive) return;
      /* Modal uses z-index near max int — confetti must sit above it */
      var confettiZ = 2147483647;
      if (typeof window.confetti !== 'function') {
        fireBenefitsConfettiFallback();
        return;
      }
      var colors = ['#D4AF37', '#F5D76E', '#C9A227', '#FFEAA7', '#B8860B', '#E8C547'];
      var burst = function () {
        if (!benefitsConfettiActive) return;
        window.confetti({
          particleCount: 55,
          startVelocity: 32,
          spread: 90,
          ticks: 320,
          gravity: 0.85,
          scalar: 1.05,
          origin: { x: Math.random() * 0.8 + 0.1, y: 0 },
          colors: colors,
          disableForReducedMotion: false,
          zIndex: confettiZ,
        });
      };
      burst();
      benefitsConfettiTimer = window.setInterval(burst, 280);
    });
  }

  var REVIEW_THANKYOU_COUPON = 'milano5';

  function reviewSuccessFirstName(fullName) {
    var part = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)[0];
    return part || 'Cliente';
  }

  function showReviewSuccessModal(fullName) {
    var firstName = reviewSuccessFirstName(fullName);
    qsa('[data-review-success-name]').forEach(function (el) {
      el.textContent = firstName;
    });
    openModal('mco-review-success-modal');
    fireBenefitsConfetti();
  }

  function finishBenefitsSuccess(payload) {
    writeBenefitsLead(payload);
    try {
      sessionStorage.setItem('mco_coupon', COUPON_CODE);
      sessionStorage.setItem('mco_benefits_seen', '1');
    } catch (err2) {}
    /* Keep success step open until CTA or outside tap — never auto-close */
    showBenefitsStep(2);
    var modal = qs('#mco-benefits-modal');
    if (modal && !modal.classList.contains('is-open')) {
      openModal('mco-benefits-modal');
    }
    fireBenefitsConfetti();
    var fab = qs('#mco-benefits-fab');
    if (fab) {
      fab.classList.add('is-visible');
      startBenefitsTimer(fab);
    }
    if (typeof scheduleSamaraTooltip === 'function') {
      scheduleSamaraTooltip(true);
    }
    /* Prefer cart AJAX only — avoid /discount/ navigation side-effects while modal is open */
    fetch(shopifyRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: COUPON_CODE }),
    }).catch(function () {
      /* Coupon may not apply until cart has items — benefits UI stays open either way */
    });
  }

  /**
   * Creates/updates a Shopify Customer via the native newsletter-style customer form
   * (POST /contact, form_type=customer) with tag Popup10. Lands in Admin → Customers.
   *
   * Shopify's contact response is unreliable over fetch (redirects / soft errors) even when
   * the customer is created successfully — so after a valid local submit we always show success.
   * Native form POST is disabled (button type=button + neutralized action) so captcha/bot
   * protection cannot force a full-page reload that flashes success then closes the modal.
   */
  function submitBenefitsForm() {
    var form = qs('#mco-benefits-form');
    var name = ((qs('#mco-benefits-name') || {}).value || '').trim();
    var email = ((qs('#mco-benefits-email') || {}).value || '').trim().toLowerCase();
    var wa = (qs('#mco-benefits-wa') || {}).value || '';
    var digits = brWhatsappDigits(wa);
    var phone = toE164BrWhatsapp(digits);

    if (!name || !isValidEmail(email) || digits.length < 10) {
      showBenefitsError('Preencha nome, e-mail e um WhatsApp válido.');
      return;
    }

    showBenefitsError('');
    setBenefitsSubmitting(true);

    var noteWa = qs('#mco-benefits-note-wa');
    var phoneHidden = qs('#mco-benefits-phone-e164');
    if (noteWa) noteWa.value = phone;
    if (phoneHidden) phoneHidden.value = phone;

    var params = new URLSearchParams();
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (value, key) {
        /* SMS consent fields can make Shopify return a non-success status even when the customer is saved */
        if (key.indexOf('sms_marketing_consent') !== -1) return;
        params.append(key, value);
      });
    } else {
      params.append('form_type', 'customer');
      params.append('utf8', '✓');
      params.append('contact[tags]', 'Popup10');
      params.append('contact[first_name]', name);
      params.append('contact[email]', email);
    }
    params.set('form_type', 'customer');
    params.set('contact[first_name]', name);
    params.set('contact[email]', email);
    params.set('contact[tags]', 'Popup10');
    params.set('contact[note][WhatsApp]', phone);
    params.set('contact[phone]', phone);
    params.delete('contact[sms_marketing_consent][state]');
    params.delete('contact[sms_marketing_consent][opt_in_level]');
    params.delete('contact[sms_marketing_consent][consent_updated_at]');

    var payload = {
      name: name,
      email: email,
      wa: digits,
      phone: phone,
      tag: 'Popup10',
      at: Date.now(),
      coupon: COUPON_CODE,
    };

    var root = shopifyRoot();
    var contactUrl = root.replace(/\/?$/, '/') + 'contact';
    fetch(contactUrl, {
      method: 'POST',
      body: params.toString(),
      headers: {
        Accept: 'application/json, text/javascript, text/html, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      redirect: 'manual',
    })
      .catch(function () {
        /* Ignore network/redirect noise — customer create often still succeeded server-side */
        return null;
      })
      .then(function () {
        syncBenefitsCustomerPhone(email, phone, name).catch(function () {
          return null;
        });
        finishBenefitsSuccess(payload);
      })
      .finally(function () {
        setBenefitsSubmitting(false);
      });
  }

  /**
   * Syncs WhatsApp into customer.phone via optional Admin sync endpoint.
   * Configure window.MCO_BENEFITS_PHONE_SYNC = { url, key } from theme layout when available.
   */
  function syncBenefitsCustomerPhone(email, phone, name) {
    var cfg = window.MCO_BENEFITS_PHONE_SYNC || null;
    if (!cfg || !cfg.url) return Promise.resolve(null);
    var headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    if (cfg.key) headers['x-mco-sync-key'] = cfg.key;
    return fetch(cfg.url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        email: email,
        phone: phone,
        first_name: name,
        tag: 'Popup10',
        source: 'benefits-popup',
      }),
    }).then(function (r) {
      if (!r.ok) throw new Error('phone sync failed');
      return r.json();
    });
  }

  var benefitsForm = qs('#mco-benefits-form');
  if (benefitsForm) {
    /* Neutralize native POST so Shopify captcha / bot scripts cannot force a reload */
    try {
      benefitsForm.setAttribute('data-mco-action', benefitsForm.getAttribute('action') || '/contact');
      benefitsForm.setAttribute('action', '#');
      benefitsForm.setAttribute('onsubmit', 'return false');
      /* form.submit() bypasses submit listeners — captcha often uses this */
      benefitsForm.submit = function () {
        return false;
      };
    } catch (errNeutralize) {}
    benefitsForm.addEventListener(
      'submit',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      },
      true
    );
  }

  var benefitsSubmitBtn = qs('#mco-benefits-submit');
  if (benefitsSubmitBtn) {
    benefitsSubmitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      submitBenefitsForm();
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-benefits-skip]')) {
      e.preventDefault();
      closeModal(qs('#mco-benefits-modal'));
      var fab = qs('#mco-benefits-fab');
      if (fab) fab.classList.add('is-visible');
      return;
    }

    var shopCta = e.target.closest('[data-mco-benefits-shop]');
    if (shopCta) {
      e.preventDefault();
      closeModal(qs('#mco-benefits-modal'));
    }

    var reviewCouponCta = e.target.closest('[data-mco-review-success-cta]');
    if (reviewCouponCta) {
      e.preventDefault();
      try {
        sessionStorage.setItem('mco_coupon', REVIEW_THANKYOU_COUPON);
      } catch (errCoupon) {}
      stopBenefitsConfetti();
      closeModal(qs('#mco-review-success-modal'));
      var allProductsUrl = shopifyRoot() + 'collections/all';
      applyCoupon(REVIEW_THANKYOU_COUPON)
        .catch(function () {})
        .finally(function () {
          window.location.href = allProductsUrl;
        });
      return;
    }

    var reviewLaterCta = e.target.closest('[data-mco-review-success-later]');
    if (reviewLaterCta) {
      e.preventDefault();
      stopBenefitsConfetti();
      closeModal(qs('#mco-review-success-modal'));
    }
  });

  var timerInterval;
  var benefitsTimerEnd = 0;
  var benefitsTimerBound = false;
  var benefitsTimerFab = null;
  function startBenefitsTimer(fab) {
    if (!fab) return;
    benefitsTimerFab = fab;
    var existingStore = typeof readCouponStore === 'function' ? readCouponStore() : null;
    var now = Date.now();
    if (existingStore && existingStore.end && existingStore.end > now && !existingStore.done) {
      benefitsTimerEnd = existingStore.end;
    } else if (!benefitsTimerEnd || benefitsTimerEnd <= now) {
      benefitsTimerEnd = now + 10 * 60 * 1000;
      if (typeof writeCouponStore === 'function') {
        writeCouponStore({
          end: benefitsTimerEnd,
          ip: (existingStore && existingStore.ip) || '',
          started: now,
        });
      }
    }
    clearInterval(timerInterval);
    timerInterval = null;

    function tick() {
      var left = Math.max(0, benefitsTimerEnd - Date.now());
      var text = Math.floor(left / 60000) + ':' + String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
      var activeFab = benefitsTimerFab || fab;
      var el = activeFab.querySelector('[data-benefits-timer]');
      if (el) el.textContent = text;
      qsa('[data-benefits-success-timer]').forEach(function (node) {
        node.textContent = text;
      });
      if (typeof updateCartCouponTimers === 'function') {
        updateCartCouponTimers(text);
      }
      if (left > 0 && left <= 60000) {
        activeFab.classList.add('is-expiring');
      }
      if (left <= 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        activeFab.classList.remove('is-visible', 'is-expiring');
      }
    }

    function syncTimer() {
      var activeFab = benefitsTimerFab || fab;
      var modalOpen = !!qs('#mco-benefits-modal.is-open');
      var onScreen = (activeFab.classList.contains('is-visible') || modalOpen) && !document.hidden;
      if (onScreen) {
        tick();
        if (!timerInterval) timerInterval = setInterval(tick, 1000);
      } else if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
    }

    syncTimer();
    if (!benefitsTimerBound) {
      benefitsTimerBound = true;
      document.addEventListener('visibilitychange', syncTimer);
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(syncTimer).observe(fab, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  try {
    if (!readBenefitsLead() && !sessionStorage.getItem('mco_benefits_seen')) {
      setTimeout(function () {
        if (readBenefitsLead()) return;
        if (!qs('#mco-benefits-modal')) return;
        openModal('mco-benefits-modal');
        showBenefitsStep(1);
        loadBenefitsConfetti(function () {});
        sessionStorage.setItem('mco_benefits_seen', '1');
      }, 4000);
    }
  } catch (err) {}

  /* Restore timer FAB if benefits already claimed and countdown still active */
  (function restoreBenefitsFab() {
    var lead = readBenefitsLead();
    if (!lead) return;
    var fab = qs('#mco-benefits-fab');
    if (!fab) return;
    var store = typeof readCouponStore === 'function' ? readCouponStore() : null;
    var end = store && store.end && !store.done ? store.end : 0;
    if (end > Date.now()) {
      fab.classList.add('is-visible');
      startBenefitsTimer(fab);
    }
  })();

  /* ---- Bottom glass nav (after 10% scroll, hide near page end) ---- */
  var bottomNav = qs('#mco-bottom-nav');
  if (bottomNav) {
    var updateBottomNav = function () {
      var doc = document.documentElement;
      var scrollable = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var progress = (window.scrollY || window.pageYOffset) / scrollable;
      var show = progress > 0.1 && progress < 0.9;
      bottomNav.classList.toggle('is-visible', show);
      bottomNav.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('mco-bottom-nav-active', show);
    };
    window.addEventListener('scroll', updateBottomNav, { passive: true });
    window.addEventListener('resize', updateBottomNav, { passive: true });
    updateBottomNav();
  }

  /* ---- Sticky ATC (after 15% scroll) ---- */
  var sticky = qs('#mco-sticky-atc');
  if (sticky) {
    var stickyFooterInView = false;
    var updateStickyAtc = function () {
      var doc = document.documentElement;
      var scrollable = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var progress = (window.scrollY || window.pageYOffset) / scrollable;
      var show = progress > 0.15 && !(stickyFooterInView && window.matchMedia('(max-width: 989px)').matches);
      sticky.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('mco-sticky-atc-visible', show);
      document.body.classList.toggle('mco-sticky-atc-visible', show);
      if (show) {
        var h = Math.ceil(sticky.getBoundingClientRect().height) || 70;
        document.documentElement.style.setProperty('--mco-sticky-atc-height', h + 'px');
      } else {
        document.documentElement.style.removeProperty('--mco-sticky-atc-height');
      }
    };
    window.addEventListener('scroll', updateStickyAtc, { passive: true });
    window.addEventListener('resize', updateStickyAtc, { passive: true });
    var stickyFooter = qs('.mco-footer, footer, .site-footer');
    if (stickyFooter && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyFooterInView = entries[0].isIntersecting;
        updateStickyAtc();
      }).observe(stickyFooter);
    }
    updateStickyAtc();
  }

  /* ---- PDP gallery (fade + thumbs + arrows) ---- */
  function setPdpNavDimmed(carousel, dimmed) {
    qsa('.mco-pdp__nav', carousel).forEach(function (nav) {
      nav.classList.toggle('is-dimmed', dimmed);
    });
  }

  function schedulePdpNavAutoDim(carousel, index) {
    if (carousel._mcoNavHideTimer) {
      clearTimeout(carousel._mcoNavHideTimer);
      carousel._mcoNavHideTimer = null;
    }
    // Full opacity on 1st–3rd images; dim to 50% after 1s from the 4th onward.
    if (index < 3) {
      setPdpNavDimmed(carousel, false);
      return;
    }
    setPdpNavDimmed(carousel, false);
    carousel._mcoNavHideTimer = setTimeout(function () {
      setPdpNavDimmed(carousel, true);
      carousel._mcoNavHideTimer = null;
    }, 1000);
  }

  function syncPdpSlideMedia(carousel) {
    if (!carousel) return;
    qsa('.mco-pdp__main-slide', carousel).forEach(function (slide) {
      var isActive = slide.classList.contains('is-active');
      qsa('video.mco-pdp__main-video', slide).forEach(function (video) {
        if (isActive) {
          video.setAttribute('data-mco-pdp-video-active', '');
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.removeAttribute('data-mco-pdp-video-active');
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {
            /* ignore */
          }
        }
      });
      qsa('iframe.mco-pdp__video-iframe', slide).forEach(function (iframe) {
        var src = iframe.getAttribute('data-src') || '';
        if (isActive) {
          if (src && iframe.getAttribute('src') !== src) {
            iframe.setAttribute('src', src);
          }
        } else if (iframe.getAttribute('src')) {
          iframe.removeAttribute('src');
        }
      });
    });
  }

  function goToPdpSlide(carousel, index) {
    if (!carousel) return;
    var slides = qsa('.mco-pdp__main-slide', carousel);
    var thumbs = qsa('.mco-pdp__thumb', carousel);
    if (!slides.length) return;
    var i = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach(function (slide, idx) {
      slide.classList.toggle('is-active', idx === i);
    });
    thumbs.forEach(function (thumb, idx) {
      thumb.classList.toggle('is-active', idx === i);
    });
    carousel.setAttribute('data-current', String(i));
    syncPdpSlideMedia(carousel);
    schedulePdpNavAutoDim(carousel, i);
  }

  function stepPdpSlide(carousel, delta) {
    var current = parseInt(carousel.getAttribute('data-current') || '0', 10);
    goToPdpSlide(carousel, current + delta);
  }

  function initPdpGallery() {
    qsa('[data-mco-pdp-carousel]').forEach(function (carousel) {
      var prev = qs('.mco-pdp__nav--prev', carousel);
      var next = qs('.mco-pdp__nav--next', carousel);
      var hitPrev = qs('.mco-pdp__hit--prev', carousel);
      var hitNext = qs('.mco-pdp__hit--next', carousel);
      var current = parseInt(carousel.getAttribute('data-current') || '0', 10);

      if (prev) {
        prev.addEventListener('click', function () {
          stepPdpSlide(carousel, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          stepPdpSlide(carousel, 1);
        });
      }
      if (hitPrev) {
        hitPrev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (carousel._mcoSwipeMoved) {
            carousel._mcoSwipeMoved = false;
            return;
          }
          stepPdpSlide(carousel, -1);
        });
      }
      if (hitNext) {
        hitNext.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (carousel._mcoSwipeMoved) {
            carousel._mcoSwipeMoved = false;
            return;
          }
          stepPdpSlide(carousel, 1);
        });
      }

      qsa('.mco-pdp__thumb', carousel).forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToPdpSlide(carousel, parseInt(btn.getAttribute('data-index'), 10));
        });
      });

      initPdpSwipe(carousel);
      syncPdpSlideMedia(carousel);
      schedulePdpNavAutoDim(carousel, current);
    });
  }

  function initPdpSwipe(carousel) {
    var main = qs('.mco-pdp__main', carousel);
    if (!main) return;
    var slides = qsa('.mco-pdp__main-slide', carousel);
    if (slides.length < 2) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var threshold = 40;

    function handleSwipe(dx, dy) {
      if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return false;
      var current = parseInt(carousel.getAttribute('data-current') || '0', 10);
      goToPdpSlide(carousel, dx < 0 ? current + 1 : current - 1);
      return true;
    }

    main.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
        carousel._mcoSwipeMoved = false;
      },
      { passive: true }
    );

    main.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (handleSwipe(e.changedTouches[0].clientX - startX, e.changedTouches[0].clientY - startY)) {
          carousel._mcoSwipeMoved = true;
        }
      },
      { passive: true }
    );

    main.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.target.closest('.mco-pdp__nav, .mco-pdp__hit, .mco-pdp__zoom-trigger, button, a')) return;
      startX = e.clientX;
      startY = e.clientY;
      tracking = true;
      carousel._mcoSwipeMoved = false;
    });

    main.addEventListener('pointerup', function (e) {
      if (!tracking || e.pointerType === 'touch') return;
      tracking = false;
      if (handleSwipe(e.clientX - startX, e.clientY - startY)) {
        carousel._mcoSwipeMoved = true;
      }
    });

    main.addEventListener('pointercancel', function () {
      tracking = false;
    });
  }

  /* ---- PDP accordions ---- */
  function initPdpAccordions() {
    qsa('.mco-pdp__acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mco-pdp__acc');
        if (!item) return;
        var panel = qs('.mco-pdp__acc-panel', item);
        if (!panel) return;
        var isOpen = panel.classList.contains('is-open');
        panel.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  initPdpGallery();
  initPdpAccordions();
  initPdpReviews();

  function setupReviewLoop(track) {
    if (!track) return;
    track.querySelectorAll('[data-review-clone]').forEach(function (el) {
      el.remove();
    });
    var items = track.querySelectorAll('.product-reviews-carousel-item');
    if (items.length < 2) return;
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(items, function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('data-review-clone', '1');
      frag.appendChild(clone);
    });
    track.appendChild(frag);
    var half = track.scrollWidth / 2;
    if (half > 10) {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = half;
    }
    if (track._mcoLoopBound) return;
    track._mcoLoopBound = true;
    var adjusting = false;
    track.addEventListener('scroll', function () {
      if (adjusting) return;
      var half = track.scrollWidth / 2;
      if (half < 10) return;
      if (track.scrollLeft > half) {
        adjusting = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft - half;
        adjusting = false;
      } else if (track.scrollLeft <= 0) {
        adjusting = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = half - 1;
        adjusting = false;
      }
    });
  }

  function initPdpReviews() {
    var track = qs('[data-mco-reviews-track]');
    if (!track) return;
    setupReviewLoop(track);
    document.addEventListener('mco:reviews-updated', function (e) {
      var section = e.target;
      var updated = section && section.querySelector ? section.querySelector('[data-mco-reviews-track]') : null;
      if (updated) setupReviewLoop(updated);
    });

    var section = track.closest('.mco-pdp-reviews');
    var prevBtn = section ? qs('.product-reviews-prev', section) : null;
    var nextBtn = section ? qs('.product-reviews-next', section) : null;
    var isPageStack = !!(section && section.classList.contains('mco-reviews-page'));
    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;
    var dragMoved = false;

    function isDesktopCarousel() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function scrollByItem(direction) {
      if (isPageStack && !isDesktopCarousel()) return;
      var item = qs('.product-reviews-carousel-item', track);
      if (!item) return;
      var gap = 0;
      track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByItem(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByItem(1); });

    track.addEventListener('mousedown', function (e) {
      if (isPageStack && !isDesktopCarousel()) return;
      isDragging = true;
      dragMoved = false;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('mouseleave', function () {
      isDragging = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mouseup', function () {
      isDragging = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      dragMoved = true;
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });

    var reviewLightbox = qs('#productReviewLightbox');
    var reviewLightboxOverlay = qs('#productReviewLightboxOverlay');
    var reviewLightboxClose = qs('#productReviewLightboxClose');
    var modal = qs('#reviewSubmitModal');

    if (reviewLightbox && reviewLightbox.parentElement !== document.body) {
      document.body.appendChild(reviewLightbox);
    }

    function closeReviewLightbox() {
      if (!reviewLightbox) return;
      reviewLightbox.classList.remove('active');
      reviewLightbox.setAttribute('aria-hidden', 'true');
      var lightboxImg = qs('#productReviewLightboxImage');
      if (lightboxImg) lightboxImg.src = '';
      if (!modal || !modal.classList.contains('active')) {
        document.body.style.overflow = '';
      }
    }

    function setReviewModalText(sel, value) {
      var el = reviewLightbox ? qs(sel, reviewLightbox) : null;
      if (!el) return;
      el.textContent = value || '';
      el.hidden = !value;
    }

    function openReviewLightbox(btn) {
      var src = btn && btn.getAttribute ? btn.getAttribute('data-review-lightbox-src') : '';
      if (!reviewLightbox || !src) return;
      var lightboxImg = qs('#productReviewLightboxImage');
      if (!lightboxImg) return;
      lightboxImg.src = src;
      setReviewModalText('[data-review-modal-name]', btn.getAttribute('data-review-name') || '');
      setReviewModalText('[data-review-modal-date]', btn.getAttribute('data-review-date') || '');
      setReviewModalText('[data-review-modal-text]', btn.getAttribute('data-review-text') || '');
      var verifiedEl = qs('[data-review-modal-verified]', reviewLightbox);
      if (verifiedEl) verifiedEl.hidden = btn.getAttribute('data-review-verified') !== '1';
      reviewLightbox.classList.add('active');
      reviewLightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    /* Delegate so ERP-injected review cards work after async feed load */
    track.addEventListener('click', function (e) {
      var lightboxBtn = e.target.closest('[data-review-lightbox-src]');
      if (lightboxBtn && track.contains(lightboxBtn)) {
        if (dragMoved) return;
        openReviewLightbox(lightboxBtn);
        return;
      }

      var readMoreBtn = e.target.closest('.product-review-read-more');
      if (!readMoreBtn || !track.contains(readMoreBtn)) return;
      e.preventDefault();
      e.stopPropagation();
      var paragraph = readMoreBtn.closest('.product-review-text');
      if (!paragraph) return;
      var fullText = paragraph.getAttribute('data-full-text');
      if (!fullText) return;
      paragraph.classList.remove('product-review-text--clamped');
      paragraph.removeAttribute('data-full-text');
      paragraph.textContent = fullText;
    });

    if (reviewLightboxOverlay) {
      reviewLightboxOverlay.addEventListener('click', function (e) {
        e.preventDefault();
        closeReviewLightbox();
      });
    }
    if (reviewLightboxClose) {
      reviewLightboxClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeReviewLightbox();
      });
    }
    if (reviewLightbox) {
      reviewLightbox.addEventListener('click', function (e) {
        if (e.target === reviewLightbox || e.target === reviewLightboxOverlay) {
          closeReviewLightbox();
        }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && reviewLightbox && reviewLightbox.classList.contains('active')) {
        closeReviewLightbox();
      }
    });

    var openBtn = qs('#productReviewOpenBtn');
    var closeBtn = qs('#reviewSubmitModalClose');
    var overlay = qs('#reviewSubmitModalOverlay');
    var form = qs('#reviewSubmitForm');
    var errorBox = qs('#reviewSubmitFormError');
    var fileInput = qs('#reviewSubmitPhotos');
    var filePreviews = qs('#reviewSubmitFilePreviews');
    var submitBtn = qs('#reviewSubmitModalCta');
    var modalLoader = qs('#reviewSubmitModalLoader');
    var uploadedPhotos = [];
    var uploadCounter = 0;
    var maxReviewPhotos = 8;
    var ratingKeys = ['design', 'qualidade', 'atendimento', 'entrega', 'experiencia'];
    var ratingLabels = {
      design: 'Design',
      qualidade: 'Qualidade',
      atendimento: 'Atendimento',
      entrega: 'Entrega',
      experiencia: 'Experiência',
    };

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    if (reviewLightbox && reviewLightbox.parentElement !== document.body) {
      document.body.appendChild(reviewLightbox);
    }

    function setReviewModalLoading(isLoading) {
      if (modalLoader) {
        modalLoader.classList.toggle('is-visible', !!isLoading);
        modalLoader.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
      }
      if (submitBtn) submitBtn.disabled = !!isLoading;
      if (closeBtn) closeBtn.disabled = !!isLoading;
    }

    function resetReviewPhotos() {
      uploadedPhotos.forEach(function (item) {
        if (item.abort) {
          try { item.abort(); } catch (e) {}
        }
        if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
      });
      uploadedPhotos = [];
      window.__mcoReviewGofileFolderId = '';
      window.__mcoReviewGofileToken = '';
      if (filePreviews) filePreviews.innerHTML = '';
      if (fileInput) fileInput.value = '';
    }

    function getCompletedPhotoCount() {
      return uploadedPhotos.filter(function (item) { return item.status === 'done' && item.url; }).length;
    }

    function getPendingPhotoCount() {
      return uploadedPhotos.filter(function (item) { return item.status === 'uploading'; }).length;
    }

    function updatePhotoProgress(item, progress) {
      item.progress = progress;
      if (!item.element) return;
      var bar = item.element.querySelector('.review-submit-file-preview-progress-bar');
      if (bar) bar.style.width = Math.max(0, Math.min(100, progress)) + '%';
    }

    function markPhotoDone(item, url, provider) {
      item.status = 'done';
      item.url = url;
      item.provider = provider || '';
      item.progress = 100;
      if (item.element) {
        item.element.classList.remove('is-uploading', 'is-error');
        var progressWrap = item.element.querySelector('.review-submit-file-preview-progress');
        if (progressWrap) progressWrap.remove();
      }
    }

    function markPhotoError(item, message) {
      item.status = 'error';
      item.error = message || 'Falha no upload';
      if (item.element) {
        item.element.classList.remove('is-uploading');
        item.element.classList.add('is-error');
        var progressWrap = item.element.querySelector('.review-submit-file-preview-progress');
        if (progressWrap) progressWrap.remove();
      }
    }

    function renderPhotoPreview(item) {
      if (!filePreviews) return;
      var wrap = document.createElement('div');
      wrap.className = 'review-submit-file-preview' + (item.status === 'uploading' ? ' is-uploading' : '');
      wrap.setAttribute('data-upload-id', item.id);

      var img = document.createElement('img');
      img.src = item.previewUrl || '';
      img.alt = '';
      wrap.appendChild(img);

      if (item.status === 'uploading') {
        var progressWrap = document.createElement('div');
        progressWrap.className = 'review-submit-file-preview-progress';
        var progressBar = document.createElement('span');
        progressBar.className = 'review-submit-file-preview-progress-bar';
        progressBar.style.width = (item.progress || 0) + '%';
        progressWrap.appendChild(progressBar);
        wrap.appendChild(progressWrap);
      }

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'review-submit-file-preview-remove';
      removeBtn.setAttribute('aria-label', 'Remover foto');
      removeBtn.innerHTML = '&times;';
      removeBtn.addEventListener('click', function () {
        if (item.abort) {
          try { item.abort(); } catch (e) {}
        }
        uploadedPhotos = uploadedPhotos.filter(function (photo) {
          if (photo.id === item.id) {
            if (photo.previewUrl) URL.revokeObjectURL(photo.previewUrl);
            if (photo.element && photo.element.parentNode) photo.element.parentNode.removeChild(photo.element);
            return false;
          }
          return true;
        });
      });
      wrap.appendChild(removeBtn);

      filePreviews.appendChild(wrap);
      item.element = wrap;
    }

    function compressReviewImage(file) {
      return new Promise(function (resolve) {
        if (!file || !/^image\//i.test(file.type || '')) {
          resolve(file);
          return;
        }
        var maxSide = 1600;
        var quality = 0.82;
        var needsTranscode = !/^image\/(jpeg|png|webp|gif)$/i.test(file.type || '');
        var img = new Image();
        var objectUrl = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(objectUrl);
          var w = img.naturalWidth || img.width;
          var h = img.naturalHeight || img.height;
          if (!w || !h) {
            resolve(file);
            return;
          }
          var scale = Math.min(1, maxSide / Math.max(w, h));
          var cw = Math.max(1, Math.round(w * scale));
          var ch = Math.max(1, Math.round(h * scale));
          var canvas = document.createElement('canvas');
          canvas.width = cw;
          canvas.height = ch;
          var ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(file);
            return;
          }
          ctx.drawImage(img, 0, 0, cw, ch);
          canvas.toBlob(
            function (blob) {
              if (!blob) {
                resolve(file);
                return;
              }
              /* Always re-encode HEIC/HEIF (and other non-web types) so hosts accept the file. */
              if (!needsTranscode && blob.size >= file.size) {
                resolve(file);
                return;
              }
              var name = (file.name || 'review-photo.jpg').replace(/\.[^.]+$/, '') + '.jpg';
              resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
            },
            'image/jpeg',
            quality
          );
        };
        img.onerror = function () {
          URL.revokeObjectURL(objectUrl);
          resolve(file);
        };
        img.src = objectUrl;
      });
    }

    function xhrFormUpload(url, formData, onProgress, assignAbort) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.responseType = 'text';
        xhr.upload.onprogress = function (event) {
          if (!event.lengthComputable || typeof onProgress !== 'function') return;
          onProgress(Math.round((event.loaded / event.total) * 100));
        };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(xhr.responseText || '');
            return;
          }
          reject(new Error('upload_http_' + xhr.status));
        };
        xhr.onerror = function () { reject(new Error('upload_network')); };
        xhr.onabort = function () { reject(new Error('upload_aborted')); };
        if (typeof assignAbort === 'function') {
          assignAbort(function () { xhr.abort(); });
        }
        xhr.send(formData);
      });
    }

    function uploadToLitterbox(file, onProgress) {
      var formData = new FormData();
      formData.append('reqtype', 'fileupload');
      formData.append('time', '72h');
      formData.append('fileToUpload', file, file.name || 'review-photo.jpg');
      return xhrFormUpload(
        'https://litterbox.catbox.moe/resources/internals/api.php',
        formData,
        onProgress
      ).then(function (text) {
        var url = String(text || '').trim();
        if (!/^https?:\/\/litter\.catbox\.moe\//i.test(url)) {
          throw new Error('invalid_upload_url');
        }
        return { url: url, provider: 'litterbox', permanent: false };
      });
    }

    function uploadToGofile(file, onProgress) {
      return fetch('https://api.gofile.io/servers')
        .then(function (r) { return r.json(); })
        .then(function (serverJson) {
          var servers = serverJson && serverJson.data && serverJson.data.servers;
          if (!servers || !servers.length) throw new Error('gofile_no_server');
          var server = servers[0].name;
          var formData = new FormData();
          formData.append('file', file, file.name || 'review-photo.jpg');
          if (window.__mcoReviewGofileFolderId) {
            formData.append('folderId', window.__mcoReviewGofileFolderId);
          }
          if (window.__mcoReviewGofileToken) {
            formData.append('token', window.__mcoReviewGofileToken);
          }
          return xhrFormUpload('https://' + server + '.gofile.io/uploadFile', formData, onProgress)
            .then(function (text) {
              var json = JSON.parse(text || '{}');
              if (!json || json.status !== 'ok' || !json.data) throw new Error('gofile_failed');
              if (json.data.guestToken) window.__mcoReviewGofileToken = json.data.guestToken;
              if (json.data.parentFolder) window.__mcoReviewGofileFolderId = json.data.parentFolder;
              var page = json.data.downloadPage || '';
              if (!page) throw new Error('gofile_no_page');
              return {
                url: page,
                provider: 'gofile',
                permanent: true,
                folderPage: json.data.parentFolderCode
                  ? ('https://gofile.io/d/' + json.data.parentFolderCode)
                  : page,
              };
            });
        });
    }

    function uploadToImgbb(file, onProgress, apiKey) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          var dataUrl = String(reader.result || '');
          var base64 = dataUrl.replace(/^data:[^;]+;base64,/, '');
          if (!base64) {
            reject(new Error('invalid_image'));
            return;
          }
          var body = new URLSearchParams();
          body.append('key', apiKey);
          body.append('image', base64);
          body.append('name', (file.name || 'review-photo').replace(/\.[^.]+$/, ''));

          var xhr = new XMLHttpRequest();
          xhr.open('POST', 'https://api.imgbb.com/1/upload', true);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
          xhr.upload.onprogress = function (event) {
            if (!event.lengthComputable || typeof onProgress !== 'function') return;
            onProgress(Math.round((event.loaded / event.total) * 100));
          };
          xhr.onload = function () {
            try {
              var json = JSON.parse(xhr.responseText || '{}');
              var url = json && json.data && (json.data.url || json.data.display_url);
              if (xhr.status >= 200 && xhr.status < 300 && url) {
                resolve({ url: url, provider: 'imgbb', permanent: true });
                return;
              }
              reject(new Error((json && json.error && json.error.message) || 'imgbb_failed'));
            } catch (err) {
              reject(new Error('imgbb_parse_failed'));
            }
          };
          xhr.onerror = function () { reject(new Error('imgbb_network')); };
          xhr.onabort = function () { reject(new Error('upload_aborted')); };
          xhr.send(body.toString());
        };
        reader.onerror = function () { reject(new Error('file_read_failed')); };
        reader.readAsDataURL(file);
      });
    }

    function uploadReviewPhotoFile(file, onProgress) {
      var cfg = window.MCO_REVIEW_UPLOAD || {};
      var imgbbKey = (cfg.imgbbKey || '').trim();

      /* Permanent direct image URL (required for Inbox / email to keep working). */
      if (imgbbKey) {
        return uploadToImgbb(file, onProgress, imgbbKey);
      }

      /*
       * Fallback without ImgBB key: Litterbox direct image URL (expires in 72h)
       * + GoFile page as backup. Direct image URL must stay primary so Inbox can open it.
       */
      var directResult = null;
      var archiveResult = null;
      return uploadToLitterbox(file, function (p) {
        if (typeof onProgress === 'function') onProgress(Math.round(p * 0.7));
      })
        .then(function (result) {
          directResult = result;
          return uploadToGofile(file, function (p) {
            if (typeof onProgress === 'function') onProgress(70 + Math.round(p * 0.3));
          }).catch(function () { return null; });
        })
        .then(function (gofileResult) {
          archiveResult = gofileResult;
          return {
            url: directResult.url,
            provider: 'litterbox',
            permanent: false,
            archiveUrl: archiveResult && archiveResult.url ? archiveResult.url : '',
            folderPage: archiveResult && archiveResult.folderPage ? archiveResult.folderPage : '',
          };
        })
        .catch(function () {
          return uploadToGofile(file, onProgress).then(function (result) {
            return {
              url: result.url,
              provider: 'gofile',
              permanent: true,
              archiveUrl: '',
              folderPage: result.folderPage || '',
            };
          });
        });
    }

    function addReviewPhoto(file) {
      if (uploadedPhotos.length >= maxReviewPhotos) {
        showReviewError('Envie no máximo ' + maxReviewPhotos + ' fotos.');
        return;
      }
      if (!file || !/^image\//i.test(file.type || '')) {
        showReviewError('Envie apenas arquivos de imagem.');
        return;
      }
      uploadCounter += 1;
      var item = {
        id: 'review-upload-' + uploadCounter,
        file: file,
        previewUrl: URL.createObjectURL(file),
        status: 'uploading',
        progress: 0,
        url: '',
        provider: '',
        permanent: false,
        abort: null,
      };
      uploadedPhotos.push(item);
      renderPhotoPreview(item);

      var cancelled = false;
      item.abort = function () { cancelled = true; };

      compressReviewImage(file)
        .then(function (prepared) {
          if (cancelled) throw new Error('upload_aborted');
          /* Prefer ERP storage: keep local File and skip third-party hosts when bridge is on. */
          var erpCfg = window.MCO_ERP_REVIEWS || {};
          if (erpCfg.enabled && erpCfg.submitToErp !== false) {
            if (prepared instanceof File) {
              item.file = prepared;
            } else if (prepared && typeof Blob !== 'undefined' && prepared instanceof Blob) {
              item.file = new File([prepared], file.name || 'review-photo.jpg', {
                type: prepared.type || file.type || 'image/jpeg',
              });
            } else {
              item.file = file;
            }
            markPhotoDone(item, item.previewUrl || '', 'erp-local');
            item.permanent = true;
            clearReviewError();
            return null;
          }
          return uploadReviewPhotoFile(prepared, function (progress) {
            if (!cancelled) updatePhotoProgress(item, Math.max(8, Math.min(96, progress)));
          });
        })
        .then(function (result) {
          if (cancelled || !result) return;
          markPhotoDone(item, result.url, result.provider);
          item.permanent = !!result.permanent;
          item.archiveUrl = result.archiveUrl || '';
          if (result.folderPage) item.folderPage = result.folderPage;
          clearReviewError();
        })
        .catch(function (err) {
          if (cancelled || (err && err.message === 'upload_aborted')) return;
          markPhotoError(item, 'Falha ao enviar foto');
          showReviewError('Não foi possível enviar uma das fotos. Remova e tente novamente.');
        });
    }

    function openReviewModal() {
      if (!modal) return;
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeReviewModal() {
      if (!modal) return;
      resetReviewPhotos();
      clearReviewError();
      setReviewModalLoading(false);
      if (form) form.reset();
      qsa('.review-star').forEach(function (star) { star.classList.remove('is-active'); });
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Enviar Avaliação';
      }
    }

    if (openBtn) openBtn.addEventListener('click', openReviewModal);
    if (closeBtn) closeBtn.addEventListener('click', closeReviewModal);
    if (overlay) overlay.addEventListener('click', closeReviewModal);

    qsa('.review-star-rating').forEach(function (group) {
      var hidden = qs('input[data-rating-input]', group);
      qsa('.review-star', group).forEach(function (star) {
        star.addEventListener('click', function () {
          var value = parseInt(star.getAttribute('data-value'), 10);
          if (hidden) hidden.value = String(value);
          qsa('.review-star', group).forEach(function (s) {
            var starValue = parseInt(s.getAttribute('data-value'), 10);
            s.classList.toggle('is-active', starValue <= value);
          });
        });
      });
    });

    if (fileInput && filePreviews) {
      var fileTrigger = qs('#reviewSubmitPhotosBtn');
      if (fileTrigger) {
        fileTrigger.addEventListener('click', function () { fileInput.click(); });
      }
      fileInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(fileInput.files || []);
        fileInput.value = '';
        if (!files.length) return;
        clearReviewError();
        files.forEach(function (file) {
          if (uploadedPhotos.length >= maxReviewPhotos) return;
          addReviewPhoto(file);
        });
      });
    }

    function showReviewError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.classList.add('is-visible');
    }

    function clearReviewError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.classList.remove('is-visible');
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearReviewError();

        var hp = qs('#mcoWebsiteHp');
        if (hp && hp.value) return;

        var name = (qs('#reviewSubmitName') && qs('#reviewSubmitName').value || '').trim();
        var email = (qs('#reviewSubmitEmail') && qs('#reviewSubmitEmail').value || '').trim();
        var text = (qs('#reviewSubmitText') && qs('#reviewSubmitText').value || '').trim();
        var missingRating = ratingKeys.some(function (key) {
          var input = form.querySelector('[data-rating-input="' + key + '"]');
          return !input || !input.value;
        });
        var photoCount = getCompletedPhotoCount();
        var pendingPhotos = getPendingPhotoCount();
        var failedPhotos = uploadedPhotos.some(function (item) { return item.status === 'error'; });

        if (pendingPhotos) {
          showReviewError('Aguarde o envio das fotos terminar antes de enviar a avaliação.');
          return;
        }

        if (failedPhotos) {
          showReviewError('Remova as fotos com falha e envie novamente.');
          return;
        }

        if (!name || !email || !text || !photoCount || missingRating) {
          showReviewError('Preencha todos os campos obrigatórios, incluindo as 5 avaliações e pelo menos uma foto.');
          return;
        }

        var productField = form.querySelector('input[name="contact[product]"]');
        var productName = productField ? productField.value : '';
        var ratingLines = ratingKeys.map(function (key) {
          var input = form.querySelector('[data-rating-input="' + key + '"]');
          return ratingLabels[key] + ': ' + (input ? input.value : '') + '/5';
        }).join('\n');

        var donePhotos = uploadedPhotos.filter(function (item) { return item.status === 'done' && item.url; });
        var allPermanent = donePhotos.every(function (item) { return item.permanent; });
        var photoLines = donePhotos.map(function (item, index) {
          var line = 'Foto ' + (index + 1) + ': ' + item.url;
          if (item.archiveUrl) line += '\n  Backup: ' + item.archiveUrl;
          return line;
        }).join('\n');
        var folderPage = '';
        donePhotos.forEach(function (item) {
          if (item.folderPage) folderPage = item.folderPage;
        });

        var body = '';
        body += '=== FOTOS DA AVALIAÇÃO ===\n';
        body += photoLines;
        if (folderPage) body += '\n\nPasta com todas as fotos: ' + folderPage;
        if (!allPermanent) {
          body += '\n\n(Os links diretos das fotos expiram em 72h — use o Backup/Pasta para guardar. Para links permanentes, adicione a chave ImgBB em Theme settings.)';
        }
        body += '\n\n=== AVALIAÇÃO ===\n';
        if (productName) body += 'Produto: ' + productName + '\n\n';
        body += text;
        body += '\n\nNotas:\n' + ratingLines;

        var params = new URLSearchParams();
        /* Keep Shopify form authenticity token when present (Liquid contact form). */
        if (form) {
          var tokenInput = form.querySelector('input[name="authenticity_token"]');
          if (tokenInput && tokenInput.value) {
            params.append('authenticity_token', tokenInput.value);
          }
        }
        params.append('form_type', 'contact');
        params.append('utf8', '✓');
        params.append('contact[name]', name);
        params.append('contact[email]', email);
        params.append('contact[body]', body);
        params.append('contact[tags]', 'product-review');
        if (productName) params.append('contact[product]', productName);
        /*
         * Dedicated fields so Shopify notification emails list each photo URL
         * as its own row (body-only links are easy to miss / truncate).
         */
        donePhotos.forEach(function (item, index) {
          params.append('contact[foto_' + (index + 1) + ']', item.url);
          if (item.archiveUrl) {
            params.append('contact[foto_' + (index + 1) + '_backup]', item.archiveUrl);
          }
        });
        if (folderPage) params.append('contact[fotos_pasta]', folderPage);

        setReviewModalLoading(true);
        if (submitBtn) submitBtn.textContent = 'Enviando...';

        fetch('/contact', {
          method: 'POST',
          body: params,
          headers: {
            Accept: 'text/html',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          credentials: 'same-origin',
        })
          .then(function (response) {
            if (!response.ok && response.status !== 422) {
              throw new Error('Não foi possível enviar sua avaliação agora.');
            }
            form.reset();
            resetReviewPhotos();
            qsa('.review-star').forEach(function (star) { star.classList.remove('is-active'); });
            closeReviewModal();
            showReviewSuccessModal(name);
          })
          .catch(function (error) {
            showReviewError(error.message || 'Não foi possível enviar sua avaliação agora.');
          })
          .finally(function () {
            setReviewModalLoading(false);
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Enviar Avaliação';
            }
          });
      });
    }

    window.__mcoErpReviewHelpers = {
      setLoading: setReviewModalLoading,
      resetPhotos: resetReviewPhotos,
      closeModal: closeReviewModal,
      showError: showReviewError,
      showSuccess: showReviewSuccessModal,
      getPhotoUrls: function () {
        return uploadedPhotos
          .filter(function (item) {
            return item.status === 'done' && item.url;
          })
          .map(function (item) {
            return item.url;
          });
      },
      getPhotoFiles: function () {
        return uploadedPhotos
          .filter(function (item) {
            return item.file;
          })
          .map(function (item) {
            return item.file;
          });
      },
    };
  }

  function buyNowFromPdp(trigger) {
    var form = qs('#mco-product-form');
    if (!form) return Promise.reject(new Error('missing product form'));
    var fd = new FormData(form);
    if (!fd.get('id')) return Promise.reject(new Error('missing variant'));

    var buttons = trigger ? [trigger] : qsa('[data-mco-buy-now]');
    buttons.forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    });

    /* Same path as "Adicionar ao Carrinho": add → open cart drawer */
    return addToCartAndOpenDrawer(form)
      .catch(function (err) {
        console.error('[Milano] buy now failed', err);
        var msg =
          (err && err.payload && (err.payload.description || err.payload.message)) ||
          'Não foi possível adicionar ao carrinho.';
        window.alert(msg);
      })
      .finally(function () {
        buttons.forEach(function (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
      });
  }

  document.addEventListener('click', function (e) {
    var buyNowBtn = e.target.closest('[data-mco-buy-now]');
    if (!buyNowBtn || buyNowBtn.disabled) return;
    e.preventDefault();
    buyNowFromPdp(buyNowBtn);
  });

  /* ---- PDP lightbox ---- */
  function initPdpLightbox() {
    var lightbox = qs('#mco-pdp-lightbox');
    if (!lightbox) return;
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }
    var lbImage = qs('.mco-pdp-lightbox__image', lightbox);
    var lbFrame = qs('.mco-pdp-lightbox__frame', lightbox);
    var lbLoader = qs('.mco-pdp-lightbox__loader', lightbox);
    var carousel = qs('[data-mco-pdp-carousel]');
    var triggers = qsa('.mco-pdp__zoom-trigger');
    var sources = [];
    var hiCache = {};
    var lbIndex = 0;
    var loadToken = 0;

    triggers.forEach(function (btn) {
      var img = qs('img', btn);
      var src = btn.getAttribute('data-full-src') || (img ? img.currentSrc || img.src : '');
      if (src) sources.push(src);
    });

    function setLightboxLoading(on) {
      if (!lightbox) return;
      lightbox.classList.toggle('is-loading', !!on);
      if (lbLoader) {
        if (on) {
          lbLoader.hidden = false;
          lbLoader.removeAttribute('hidden');
        } else {
          lbLoader.hidden = true;
          lbLoader.setAttribute('hidden', '');
        }
      }
    }

    function applyAspectRatio(index) {
      if (!lbFrame && !lbImage) return;
      var trigger = triggers[index];
      var w = trigger ? parseInt(trigger.getAttribute('data-w'), 10) : 0;
      var h = trigger ? parseInt(trigger.getAttribute('data-h'), 10) : 0;
      var ratio = w > 0 && h > 0 ? w + ' / ' + h : '';
      if (lbFrame) {
        if (ratio) lbFrame.style.aspectRatio = ratio;
        else lbFrame.style.removeProperty('aspect-ratio');
      }
      if (lbImage) {
        if (ratio) lbImage.style.aspectRatio = ratio;
        else lbImage.style.removeProperty('aspect-ratio');
      }
    }

    function getPlaceholderSrc(index) {
      var trigger = triggers[index];
      var img = trigger ? qs('img', trigger) : null;
      if (img) return img.currentSrc || img.src || '';
      var slide = carousel
        ? qs('.mco-pdp__main-slide[data-index="' + index + '"] img', carousel) ||
          qsa('.mco-pdp__main-slide img', carousel)[index]
        : null;
      return slide ? slide.currentSrc || slide.src || '' : '';
    }

    function prefetchHiRes(index) {
      if (!sources.length) return;
      var i = ((index % sources.length) + sources.length) % sources.length;
      var src = sources[i];
      if (!src || hiCache[src]) return;
      var preload = new Image();
      preload.decoding = 'async';
      preload.onload = function () {
        hiCache[src] = preload;
      };
      preload.onerror = function () {
        delete hiCache[src];
      };
      preload.src = src;
      hiCache[src] = preload;
    }

    function upgradeToHiRes(index, token) {
      var src = sources[index];
      if (!src || !lbImage) {
        setLightboxLoading(false);
        return;
      }
      if (hiCache[src] && hiCache[src].complete && hiCache[src].naturalWidth) {
        if (token !== loadToken) return;
        lbImage.src = src;
        setLightboxLoading(false);
        return;
      }
      setLightboxLoading(true);
      var hi = new Image();
      hi.decoding = 'async';
      hi.onload = function () {
        hiCache[src] = hi;
        if (token !== loadToken) return;
        lbImage.src = src;
        setLightboxLoading(false);
      };
      hi.onerror = function () {
        if (token !== loadToken) return;
        setLightboxLoading(false);
      };
      hi.src = src;
      hiCache[src] = hi;
    }

    function showLightboxImage(index) {
      if (!sources.length || !lbImage) return;
      lbIndex = ((index % sources.length) + sources.length) % sources.length;
      loadToken += 1;
      var token = loadToken;
      applyAspectRatio(lbIndex);

      var placeholder = getPlaceholderSrc(lbIndex);
      var hiSrc = sources[lbIndex];
      var cached = hiCache[hiSrc];
      var hasCachedHi = !!(cached && cached.complete && cached.naturalWidth);

      if (hasCachedHi) {
        lbImage.src = hiSrc;
        setLightboxLoading(false);
      } else if (placeholder) {
        lbImage.src = placeholder;
        upgradeToHiRes(lbIndex, token);
      } else {
        lbImage.src = hiSrc;
        upgradeToHiRes(lbIndex, token);
      }

      lbImage.alt = '';
      prefetchHiRes(lbIndex - 1);
      prefetchHiRes(lbIndex + 1);
    }

    function openLightbox(index) {
      if (!sources.length || !lbImage) return;
      showLightboxImage(index);
      lightbox.hidden = false;
      lightbox.removeAttribute('hidden');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mco-lightbox-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      loadToken += 1;
      setLightboxLoading(false);
      lightbox.hidden = true;
      lightbox.setAttribute('hidden', '');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mco-lightbox-open');
      document.body.style.overflow = '';
      if (lbImage) {
        lbImage.removeAttribute('src');
        lbImage.style.removeProperty('aspect-ratio');
      }
      if (lbFrame) lbFrame.style.removeProperty('aspect-ratio');
    }

    function stepLightbox(delta) {
      openLightbox(lbIndex + delta);
      if (carousel) goToPdpSlide(carousel, lbIndex);
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(parseInt(btn.getAttribute('data-mco-pdp-lightbox') || '0', 10));
      });
      /* Warm cache on intent (hover / focus) without blocking page load */
      btn.addEventListener('pointerenter', function () {
        var i = parseInt(btn.getAttribute('data-mco-pdp-lightbox') || '0', 10);
        prefetchHiRes(i);
      });
      btn.addEventListener('focus', function () {
        var i = parseInt(btn.getAttribute('data-mco-pdp-lightbox') || '0', 10);
        prefetchHiRes(i);
      });
    });

    var overlay = qs('.mco-pdp-lightbox__overlay', lightbox);
    var closeBtn = qs('.mco-pdp-lightbox__close', lightbox);
    var lbPrev = qs('.mco-pdp-lightbox__nav--prev', lightbox);
    var lbNext = qs('.mco-pdp-lightbox__nav--next', lightbox);

    if (overlay) overlay.addEventListener('click', closeLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (lbPrev) {
      lbPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        stepLightbox(-1);
      });
    }
    if (lbNext) {
      lbNext.addEventListener('click', function (e) {
        e.stopPropagation();
        stepLightbox(1);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') {
        e.stopPropagation();
        closeLightbox();
      }
      if (e.key === 'ArrowLeft') stepLightbox(-1);
      if (e.key === 'ArrowRight') stepLightbox(1);
    });
  }

  initPdpLightbox();

  /* gift bag attribute via cart.js */
  var gift = qs('#mco-gift-bag');
  if (gift) {
    gift.addEventListener('change', function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'Embalagem presente': gift.checked ? 'Sim' : '' },
        }),
      }).catch(function () {});
    });
  }

  /* ---- Novidades filter drawer + grid (WC #novidadesSection parity) ---- */
  var currentFilters = {
    orderby: 'date',
    colecoes: [],
    estilos: [],
    cores: [],
    tamanhos: [],
    pulseiras: [],
    formatos: [],
    opcionais: [],
  };
  window.currentFilters = currentFilters;

  function openFilterDrawer(sectionName) {
    var drawer = qs('#filterDrawer');
    var overlay = qs('#filterDrawerOverlay');
    if (!drawer || !overlay) return;

    if (sectionName === 'cores') sectionName = 'cor-mostrador';

    /* Escape Shopify section stacking contexts so drawer sits above filter bar */
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(overlay);
      document.body.appendChild(drawer);
    }

    drawer.classList.add('active');
    overlay.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('mco-filters-open');
    updateResultsCount();

    setTimeout(function () {
      qsa('.filter-section', drawer).forEach(function (s) {
        s.classList.remove('active');
        var c = s.querySelector('.filter-section-content');
        if (c) c.style.maxHeight = '0px';
      });
      if (sectionName) {
        var section = drawer.querySelector('[data-filter-section="' + sectionName + '"]');
        if (section) {
          var content = section.querySelector('.filter-section-content');
          section.classList.add('active');
          if (content) {
            content.style.maxHeight = 'none';
            var full = content.scrollHeight;
            content.style.maxHeight = '0px';
            content.offsetHeight;
            content.style.maxHeight = full + 'px';
          }
          section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }, 80);
  }
  window.openFilterDrawer = openFilterDrawer;

  function closeFilterDrawer() {
    var drawer = qs('#filterDrawer');
    var overlay = qs('#filterDrawerOverlay');
    if (drawer) {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
    document.documentElement.classList.remove('mco-filters-open');
  }

  function checkedValues(name) {
    return qsa('#filterDrawer input[name="' + name + '"]:checked').map(function (el) {
      return el.value;
    });
  }

  function syncFiltersFromDrawer() {
    var orderEl = qs('#filterDrawer input[name="orderby"]:checked');
    currentFilters.orderby = orderEl ? orderEl.value : 'date';
    currentFilters.colecoes = checkedValues('colecoes');
    currentFilters.estilos = checkedValues('estilos');
    currentFilters.cores = checkedValues('cores');
    currentFilters.tamanhos = checkedValues('tamanhos');
    currentFilters.pulseiras = checkedValues('pulseiras');
    currentFilters.formatos = checkedValues('formatos');
    currentFilters.opcionais = checkedValues('opcionais');
    window.currentFilters = currentFilters;
  }

  function hasActiveFilters() {
    return (
      currentFilters.colecoes.length +
        currentFilters.estilos.length +
        currentFilters.cores.length +
        currentFilters.tamanhos.length +
        currentFilters.pulseiras.length +
        currentFilters.formatos.length +
        currentFilters.opcionais.length >
        0 ||
      (currentFilters.orderby && currentFilters.orderby !== 'date')
    );
  }

  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '')
      .replace(/×/g, 'x');
  }

  /* Diâmetro buckets: Mini ≤24 · Delicado 25–28 · Clássico 29–32 · Médio 33–36 · Grande ≥37 */
  var DIAM_RANGES = {
    mini: { min: 0, max: 24 },
    delicado: { min: 25, max: 28 },
    classico: { min: 29, max: 32 },
    medio: { min: 33, max: 36 },
    grande: { min: 37, max: Infinity },
  };

  function parseDiametroMm(card) {
    var rawAttr = card.getAttribute('data-diametro-mm');
    if (rawAttr != null && String(rawAttr).trim() !== '') {
      var n = parseFloat(String(rawAttr).replace(',', '.'));
      if (!isNaN(n) && n > 0) return n;
    }
    /* Fallback: data-diametro may be "21x35mm", "Ø32", "32 mm", "21x27,5mm", or a description chunk */
    var raw = String(card.getAttribute('data-diametro') || '')
      .toLowerCase()
      .replace(/[ø⌀]/g, '')
      .replace(/×/g, 'x')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '');
    if (!raw) return NaN;
    var nums = raw.match(/(\d+(?:[.,]\d+)?)/g);
    if (!nums || !nums.length) return NaN;
    var max = 0;
    for (var i = 0; i < nums.length; i++) {
      var v = parseFloat(String(nums[i]).replace(',', '.'));
      /* Ignore tiny non-size numbers that can appear in messy description fallbacks */
      if (!isNaN(v) && v >= 10 && v <= 80 && v > max) max = v;
    }
    return max > 0 ? max : NaN;
  }

  function diametroMatches(card, selected) {
    if (!selected.length) return true;
    var mm = parseDiametroMm(card);
    if (isNaN(mm)) return false;
    return selected.some(function (t) {
      var key = normalize(t);
      var range = DIAM_RANGES[key];
      if (range) {
        return mm >= range.min && mm <= range.max;
      }
      /* Legacy exact slug fallback */
      var diam = normalize(card.getAttribute('data-diametro'));
      return diam.indexOf(key.replace(/mm$/, '')) !== -1 || diam === key;
    });
  }

  function colorMatches(cardCores, selected) {
    if (!selected.length) return true;
    var hay = normalize(cardCores);
    return selected.some(function (val) {
      var v = normalize(val);
      var tokens = v.replace(/^(mostrador|caixa|pulseira-cor|pulseira)-/, '').split(/[-_]/);
      if (hay.indexOf(v) !== -1) return true;
      return tokens.every(function (t) {
        return !t || hay.indexOf(t) !== -1;
      });
    });
  }

  function cardMatches(card, filters) {
    if (filters.colecoes.length) {
      var colecoesHay = normalize(
        (card.getAttribute('data-colecoes') || '') +
          ' ' +
          (card.getAttribute('data-colecao') || '') +
          ' ' +
          (card.getAttribute('data-tags') || '')
      );
      if (
        !filters.colecoes.some(function (c) {
          var needle = normalize(c);
          if (!needle) return false;
          return (
            colecoesHay === needle ||
            colecoesHay.indexOf(',' + needle + ',') !== -1 ||
            colecoesHay.indexOf(needle) !== -1
          );
        })
      ) {
        return false;
      }
    }
    if (filters.estilos.length) {
      var estilo = normalize(card.getAttribute('data-estilo') + ' ' + card.getAttribute('data-tags'));
      if (
        !filters.estilos.some(function (e) {
          return estilo.indexOf(normalize(e)) !== -1;
        })
      ) {
        return false;
      }
    }
    if (filters.tamanhos.length && !diametroMatches(card, filters.tamanhos)) {
      return false;
    }
    if (filters.pulseiras.length) {
      var pul = normalize(card.getAttribute('data-pulseira') + ' ' + card.getAttribute('data-tags'));
      if (
        !filters.pulseiras.some(function (p) {
          return pul.indexOf(normalize(p)) !== -1;
        })
      ) {
        return false;
      }
    }
    if (filters.formatos.length) {
      var form = normalize(card.getAttribute('data-formato') + ' ' + card.getAttribute('data-tags'));
      if (
        !filters.formatos.some(function (f) {
          return form.indexOf(normalize(f)) !== -1;
        })
      ) {
        return false;
      }
    }
    if (filters.cores.length && !colorMatches(card.getAttribute('data-cores'), filters.cores)) {
      return false;
    }
    if (filters.opcionais.length) {
      var opc = normalize(card.getAttribute('data-opcionais') + ' ' + card.getAttribute('data-tags'));
      if (
        !filters.opcionais.some(function (o) {
          return opc.indexOf(normalize(o)) !== -1;
        })
      ) {
        return false;
      }
    }
    return true;
  }

  function featuredBadgeRank(card) {
    var raw = card.getAttribute('data-badge-rank');
    if (raw != null && raw !== '') {
      var n = parseInt(raw, 10);
      if (!isNaN(n)) return n;
    }
    var pill = card.querySelector('.mco-card__pill');
    var text = pill ? String(pill.textContent || '').trim() : '';
    if (text === 'Best Seller') return 0;
    if (text === 'Novo') return 1;
    return 2;
  }

  function ensureCardSortSeed(card) {
    if (!card.getAttribute('data-sort-seed')) {
      card.setAttribute('data-sort-seed', String(Math.random()));
    }
  }

  function sortCards(cards, orderby) {
    var arr = cards.slice();
    /* Default / popularity: Best Seller → Novo → rest (random, stable per session) */
    if (!orderby || orderby === 'date' || orderby === 'popularity') {
      arr.forEach(ensureCardSortSeed);
      arr.sort(function (a, b) {
        var ra = featuredBadgeRank(a);
        var rb = featuredBadgeRank(b);
        if (ra !== rb) return ra - rb;
        if (ra === 2) {
          return (
            parseFloat(a.getAttribute('data-sort-seed') || '0') -
            parseFloat(b.getAttribute('data-sort-seed') || '0')
          );
        }
        var ca = parseInt(a.getAttribute('data-created') || '0', 10);
        var cb = parseInt(b.getAttribute('data-created') || '0', 10);
        if (cb !== ca) return cb - ca;
        var ta = (a.getAttribute('data-title') || '').toLowerCase();
        var tb = (b.getAttribute('data-title') || '').toLowerCase();
        return ta.localeCompare(tb);
      });
      return arr;
    }
    arr.sort(function (a, b) {
      var pa = parseInt(a.getAttribute('data-price') || '0', 10);
      var pb = parseInt(b.getAttribute('data-price') || '0', 10);
      var ta = (a.getAttribute('data-title') || '').toLowerCase();
      var tb = (b.getAttribute('data-title') || '').toLowerCase();
      switch (orderby) {
        case 'title-asc':
          return ta.localeCompare(tb);
        case 'title-desc':
          return tb.localeCompare(ta);
        case 'price-asc':
          return pa - pb;
        case 'price-desc':
          return pb - pa;
        default:
          return 0;
      }
    });
    return arr;
  }

  function getNovidadesRoot() {
    return qs('[data-mco-novidades]');
  }

  /* Novidades/collection grids, or related grid on PDP when filter bar is used */
  function getFilterableGridRoot() {
    return qs('[data-mco-novidades]') || qs('[data-mco-related]');
  }

  function updateResultsCount() {
    var root = getFilterableGridRoot();
    var countEl = qs('#filterResultsCount');
    if (!countEl) return;
    var draft = {
      orderby: (qs('#filterDrawer input[name="orderby"]:checked') || {}).value || 'date',
      colecoes: checkedValues('colecoes'),
      estilos: checkedValues('estilos'),
      cores: checkedValues('cores'),
      tamanhos: checkedValues('tamanhos'),
      pulseiras: checkedValues('pulseiras'),
      formatos: checkedValues('formatos'),
      opcionais: checkedValues('opcionais'),
    };
    var cards = root ? qsa('.search-product-card', root) : [];
    var n = cards.filter(function (c) {
      return cardMatches(c, draft);
    }).length;
    countEl.textContent = String(n);
  }

  function getNovidadesCols() {
    return window.matchMedia('(min-width: 990px)').matches ? 6 : 2;
  }

  function getNovidadesPageSize(root) {
    var cols = getNovidadesCols();
    var rawPageSize = parseInt((root && root.getAttribute('data-page-size')) || '12', 10) || 12;
    /* Always load full rows (6 on desktop / 2 on mobile) so grids never leave empty columns */
    var pageSize = Math.max(cols, Math.floor(rawPageSize / cols) * cols);
    if (pageSize < cols) pageSize = cols;
    /* Mobile: cap initial/page chunks at 3 rows so 12-desktop doesn't dump 6 rows at once */
    if (cols < 6) pageSize = Math.min(pageSize, cols * 3);
    return pageSize;
  }

  function getVisibleLimitForPage(page, pageSize, matchedCount, cols) {
    var requested = page * pageSize;
    if (requested >= matchedCount) {
      /* Last page: show every remaining card (partial row is OK) */
      return matchedCount;
    }
    if (matchedCount < cols) return matchedCount;
    var limit = Math.floor(requested / cols) * cols;
    if (limit < cols) limit = cols;
    return Math.min(limit, matchedCount);
  }

  var LOAD_MORE_LABEL = 'Mostrar mais criações';
  var LOAD_MORE_END_LABEL = 'Fim da vitrine';

  function setLoadMoreButtonState(moreBtn, hasMore, opts) {
    if (!moreBtn) return;
    var options = opts || {};
    var hideWhenEmpty = !!options.hideWhenEmpty;
    if (hideWhenEmpty) {
      moreBtn.hidden = true;
      moreBtn.disabled = true;
      moreBtn.classList.remove('is-end');
      moreBtn.removeAttribute('aria-disabled');
      moreBtn.textContent = LOAD_MORE_LABEL;
      return;
    }
    moreBtn.hidden = false;
    if (hasMore) {
      moreBtn.disabled = false;
      moreBtn.classList.remove('is-end');
      moreBtn.removeAttribute('aria-disabled');
      moreBtn.textContent = LOAD_MORE_LABEL;
    } else {
      moreBtn.disabled = true;
      moreBtn.classList.add('is-end');
      moreBtn.setAttribute('aria-disabled', 'true');
      moreBtn.textContent = LOAD_MORE_END_LABEL;
    }
  }

  function applyNovidadesFilters(resetPage) {
    var root = getFilterableGridRoot();
    if (!root) return;
    var grid =
      qs('[data-mco-novidades-grid]', root) ||
      qs('#novidades-products-grid', root) ||
      qs('[data-mco-related-grid]', root) ||
      qs('#related-products-grid', root);
    var moreBtn = qs('[data-mco-novidades-more]', root) || qs('[data-mco-related-more]', root);
    var emptyEl = qs('[data-mco-novidades-empty]', root);
    var clearBtn = qs('#filterClearBtn');
    if (!grid) return;

    var skeleton =
      qs('[data-mco-grid-skeleton]', root) ||
      qs('[data-mco-related-skeleton]', root) ||
      qs('[data-mco-related-more-skeleton]', root);
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var isLoadMore = !resetPage;

    if (isLoadMore) {
      root.classList.add('is-loading-more');
      root.classList.remove('is-loading');
      if (skeleton) {
        skeleton.hidden = false;
        skeleton.setAttribute('aria-hidden', 'false');
      }
    } else {
      root.classList.add('is-loading');
      root.classList.remove('is-loading-more');
      if (skeleton) {
        skeleton.hidden = false;
        skeleton.setAttribute('aria-hidden', 'false');
      }
    }
    syncFiltersFromDrawer();

    var cols = getNovidadesCols();
    var pageSize = getNovidadesPageSize(root);
    var page = resetPage ? 1 : parseInt(root.getAttribute('data-page') || '1', 10) || 1;
    if (resetPage) root.setAttribute('data-page', '1');

    var allCards = qsa('.search-product-card', grid);
    var matched = sortCards(
      allCards.filter(function (c) {
        return cardMatches(c, currentFilters);
      }),
      currentFilters.orderby
    );

    matched.forEach(function (card) {
      grid.appendChild(card);
    });
    allCards.forEach(function (card) {
      if (matched.indexOf(card) === -1) grid.appendChild(card);
    });

    var visibleLimit = getVisibleLimitForPage(page, pageSize, matched.length, cols);
    var prevVisible = isLoadMore
      ? getVisibleLimitForPage(page - 1, pageSize, matched.length, cols)
      : 0;

    matched.forEach(function (card, idx) {
      card.classList.remove('is-filtered-out');
      if (idx < visibleLimit) {
        card.classList.remove('is-page-hidden');
        if (isLoadMore && idx >= prevVisible) {
          card.classList.add('novidades-card-reveal');
        }
      } else {
        card.classList.add('is-page-hidden');
      }
    });
    allCards.forEach(function (card) {
      if (matched.indexOf(card) === -1) {
        card.classList.add('is-filtered-out');
        card.classList.remove('is-page-hidden');
      }
    });

    if (moreBtn) {
      if (matched.length < 1) {
        setLoadMoreButtonState(moreBtn, false, { hideWhenEmpty: true });
      } else {
        setLoadMoreButtonState(moreBtn, visibleLimit < matched.length);
      }
    }
    if (emptyEl) emptyEl.hidden = matched.length > 0;
    if (clearBtn) clearBtn.hidden = !hasActiveFilters();

    updateResultsCount();

    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
    });

    window.setTimeout(function () {
      root.classList.remove('is-loading');
      root.classList.remove('is-loading-more');
      if (skeleton) {
        skeleton.hidden = true;
        skeleton.setAttribute('aria-hidden', 'true');
      }
      window.scrollTo(0, scrollY);
    }, isLoadMore ? 280 : 220);
  }

  function clearNovidadesFilters() {
    qsa('#filterDrawer input[type="checkbox"]').forEach(function (el) {
      el.checked = false;
    });
    var dateRadio = qs('#order-lancamentos');
    if (dateRadio) dateRadio.checked = true;
    syncFiltersFromDrawer();
    applyNovidadesFilters(true);
  }

  function initFilterDrawer() {
    var drawer = qs('#filterDrawer');
    var overlay = qs('#filterDrawerOverlay');
    if (!drawer) return;

    var closeBtn = qs('#filterDrawerClose');
    if (closeBtn) closeBtn.addEventListener('click', closeFilterDrawer);
    if (overlay) overlay.addEventListener('click', closeFilterDrawer);

    qsa('.filter-section-header', drawer).forEach(function (header) {
      if (header.dataset.listenerAdded === 'true') return;
      header.dataset.listenerAdded = 'true';
      header.addEventListener('click', function (e) {
        e.preventDefault();
        var section = header.closest('.filter-section');
        if (!section) return;
        var content = section.querySelector('.filter-section-content');
        if (!content) {
          section.classList.toggle('active');
          return;
        }

        if (section.classList.contains('active')) {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.offsetHeight; /* reflow */
          section.classList.remove('active');
          content.style.maxHeight = '0px';
        } else {
          section.classList.add('active');
          content.style.maxHeight = 'none';
          var full = content.scrollHeight;
          content.style.maxHeight = '0px';
          content.offsetHeight; /* reflow */
          content.style.maxHeight = full + 'px';
          content.addEventListener(
            'transitionend',
            function onOpenEnd(ev) {
              if (ev.propertyName !== 'max-height') return;
              if (section.classList.contains('active')) content.style.maxHeight = 'none';
              content.removeEventListener('transitionend', onOpenEnd);
            }
          );
        }
      });
    });

    drawer.addEventListener('change', function () {
      updateResultsCount();
      var clearBtn = qs('#filterClearBtn');
      syncFiltersFromDrawer();
      if (clearBtn) clearBtn.hidden = !hasActiveFilters();
    });

    drawer.addEventListener('click', function (e) {
      var label = e.target.closest('.color-circle-label');
      if (!label) {
        qsa('.color-circle-label.tooltip-show', drawer).forEach(function (l) {
          l.classList.remove('tooltip-show');
        });
        return;
      }
      var isActive = label.classList.contains('tooltip-show');
      qsa('.color-circle-label.tooltip-show', drawer).forEach(function (l) {
        l.classList.remove('tooltip-show');
      });
      if (!isActive) label.classList.add('tooltip-show');
    });

    var applyBtn = qs('#filterApplyBtn');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var loader = qs('#filterDrawerLoader');
        if (loader) loader.setAttribute('aria-hidden', 'false');
        applyNovidadesFilters(true);
        setTimeout(function () {
          if (loader) loader.setAttribute('aria-hidden', 'true');
          closeFilterDrawer();
          var root = getFilterableGridRoot();
          if (root) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 180);
      });
    }

    var clearBtn = qs('#filterClearBtn');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearNovidadesFilters();
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mco-open-filters]');
      if (!btn) return;
      e.preventDefault();
      openFilterDrawer(btn.getAttribute('data-filter-section') || null);
    });
  }

  function initNovidadesGrid() {
    var root = getNovidadesRoot();
    if (!root) return;
    root.setAttribute('data-page', '1');
    applyNovidadesFilters(true);

    var moreBtn = qs('[data-mco-novidades-more]', root);
    if (moreBtn && !moreBtn._mcoBound) {
      moreBtn._mcoBound = true;
      moreBtn.addEventListener('click', function () {
        if (moreBtn.disabled || moreBtn.classList.contains('is-end')) return;
        var page = parseInt(root.getAttribute('data-page') || '1', 10) + 1;
        root.setAttribute('data-page', String(page));
        applyNovidadesFilters(false);
      });
    }

    var colsMq = window.matchMedia('(min-width: 990px)');
    var onColsChange = function () {
      applyNovidadesFilters(true);
    };
    if (colsMq.addEventListener) colsMq.addEventListener('change', onColsChange);
    else if (colsMq.addListener) colsMq.addListener(onColsChange);
  }

  /* ---- Cart drawer (Woo parity) ---- */
  var CART_SECTION_ID = 'milano-cart-drawer-section';

  function updateCartBadges(count) {
    qsa('.mco-cart-count').forEach(function (el) {
      if (count > 0) {
        el.textContent = String(count);
        el.setAttribute('aria-hidden', 'true');
        el.hidden = false;
      } else {
        el.remove();
      }
    });
    qsa('[data-mco-drawer="mco-cart-drawer-milano"]').forEach(function (wrap) {
      var badge = wrap.querySelector('.mco-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mco-cart-count';
          badge.setAttribute('aria-hidden', 'true');
          wrap.appendChild(badge);
        }
        badge.textContent = String(count);
        badge.setAttribute('aria-hidden', 'true');
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function isCartResumoExpanded() {
    var resumo = qs('[data-mco-cart-resumo]');
    return !!(resumo && !resumo.classList.contains('is-collapsed'));
  }

  function setCartResumoExpanded(expanded) {
    qsa('[data-mco-cart-resumo]').forEach(function (resumo) {
      var toggle = qs('[data-mco-resumo-toggle]', resumo);
      var body = qs('.cart-drawer-resumo-body', resumo);
      resumo.classList.toggle('is-collapsed', !expanded);
      if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (body) {
        body.removeAttribute('hidden');
        body.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      }
    });
  }

  function isCartDrawerOpen() {
    var d = qs('#mco-cart-drawer-milano');
    return !!(d && d.classList.contains('is-open'));
  }

  function keepCartDrawerOpen() {
    var drawer = qs('#mco-cart-drawer-milano');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mco-drawer-open', 'mco-cart-drawer-open');
    document.body.style.overflow = 'hidden';
    var isCartMobile = window.matchMedia('(max-width: 989px)').matches;
    setOverlayOpen(!isCartMobile);
  }

  function setCouponNotice(html, isError) {
    var list = qsa('.cart-drawer-coupon-notices');
    if (!list.length) return;
    list.forEach(function (notices) {
      notices.hidden = false;
      notices.removeAttribute('hidden');
      notices.innerHTML = html || '';
    });
    if (isError) setCartResumoExpanded(true);
  }

  function refreshCartDrawer(options) {
    options = options || {};
    var prepare = options.skipEsquenta ? Promise.resolve() : syncEsquentaDiscount().catch(function () {});
    return prepare.then(function () {
      return refreshCartDrawerMarkup(options);
    });
  }

  function refreshCartDrawerMarkup(options) {
    options = options || {};
    var drawer = qs('#mco-cart-drawer-milano');
    var pageInner = qs('[data-mco-cart-page-inner]');
    if (!drawer && !pageInner) return Promise.resolve();
    var wasOpen = isCartDrawerOpen();
    var preserveResumoOpen = options.expandResumo || isCartResumoExpanded();
    var noticeHtml = options.noticeHtml || '';
    var noticeIsError = !!options.noticeIsError;
    if (drawer) drawer.classList.add('is-loading');
    if (pageInner) pageInner.classList.add('is-loading');
    var url = shopifyRoot();
    return fetch(url + '?sections=' + CART_SECTION_ID)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data[CART_SECTION_ID];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var payload = doc.querySelector('[data-mco-cart-drawer-payload]');
        if (!payload) return;
        if (drawer) {
          var inner = qs('[data-mco-cart-drawer-inner]', drawer);
          if (inner) inner.innerHTML = payload.innerHTML;
        }
        if (pageInner) pageInner.innerHTML = payload.innerHTML;
        var countEl = payload.querySelector('[data-mco-cart-count]');
        var count = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
        updateCartBadges(count);
        initCartCouponBanner();
        if (wasOpen) keepCartDrawerOpen();
        if (preserveResumoOpen) setCartResumoExpanded(true);
        if (noticeHtml) setCouponNotice(noticeHtml, noticeIsError);
      })
      .catch(function () {})
      .finally(function () {
        if (drawer) drawer.classList.remove('is-loading');
        if (pageInner) pageInner.classList.remove('is-loading');
        if (wasOpen) keepCartDrawerOpen();
      });
  }

  function changeCartLine(keyOrLine, quantity) {
    var body = { quantity: quantity };
    if (typeof keyOrLine === 'string') {
      body.id = keyOrLine;
    } else {
      body.line = keyOrLine;
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed');
      return r.json();
    });
  }

  function cleanLineProperties(props) {
    var out = {};
    if (!props || typeof props !== 'object') return out;
    Object.keys(props).forEach(function (key) {
      var val = props[key];
      if (val == null || val === '') return;
      out[key] = val;
    });
    return out;
  }

  /* Move a line to the end of cart.items so reversed Liquid shows it on top */
  function promoteCartLineToTop(variantId) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var line = null;
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].variant_id) === String(variantId) || String(items[i].id) === String(variantId)) {
            line = items[i];
            break;
          }
        }
        if (!line) return cart;
        /* Already last in cart (newest) — reversed list will show it first */
        if (items[items.length - 1] && items[items.length - 1].key === line.key) {
          return cart;
        }
        var qty = line.quantity;
        var props = cleanLineProperties(line.properties);
        var payload = { id: Number(line.variant_id || variantId), quantity: qty };
        if (Object.keys(props).length) payload.properties = props;
        if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
          payload.selling_plan = line.selling_plan_allocation.selling_plan.id;
        }
        return changeCartLine(line.key, 0).then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [payload] }),
          }).then(function (r) {
            if (!r.ok) throw new Error('re-add failed');
            return r.json();
          });
        });
      });
  }

  function addToCartAndOpenDrawer(formOrData) {
    var fd;
    var variantId;
    if (window.FormData && formOrData instanceof FormData) {
      fd = formOrData;
      variantId = fd.get('id');
    } else if (formOrData && formOrData.tagName === 'FORM') {
      fd = new FormData(formOrData);
      variantId = fd.get('id');
    } else {
      return Promise.reject(new Error('invalid add payload'));
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || 'add failed');
            err.payload = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (added) {
        var id = (added && (added.variant_id || added.id)) || variantId;
        return promoteCartLineToTop(id);
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        openDrawer('mco-cart-drawer-milano');
      });
  }

  /* Used by Dawn product-form.js when no native cart-drawer is present */
  window.mcoOpenCartAfterAdd = function (variantId) {
    var id = variantId;
    return Promise.resolve()
      .then(function () {
        return id ? promoteCartLineToTop(id) : null;
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        openDrawer('mco-cart-drawer-milano');
      });
  };

  /* Intercept ALL add-to-cart forms before Dawn redirects to /cart */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1 && form.id !== 'mco-product-form') return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var submitBtns = [];
      var primary =
        form.querySelector('[type="submit"][name="add"]') ||
        form.querySelector('.mco-pdp__atc') ||
        form.querySelector('[type="submit"]');
      if (primary) submitBtns.push(primary);
      if (form.id) {
        qsa('[type="submit"][form="' + form.id + '"]').forEach(function (btn) {
          if (submitBtns.indexOf(btn) === -1) submitBtns.push(btn);
        });
      }
      submitBtns.forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      });

      addToCartAndOpenDrawer(form)
        .catch(function (err) {
          console.error('[Milano] add to cart failed', err);
          var msg =
            (err && err.payload && (err.payload.description || err.payload.message)) ||
            'Não foi possível adicionar ao carrinho.';
          window.alert(msg);
        })
        .finally(function () {
          submitBtns.forEach(function (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          });
        });
    },
    true
  );

  function setGiftBagAttribute(on, variantId) {
    if (!variantId) {
      return Promise.reject(new Error('Gift bag variant missing'));
    }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (item) {
          return String(item.variant_id) === String(variantId);
        })[0];
        if (on) {
          if (line && line.quantity > 0) return cart;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          }).then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) {
                var err = new Error((body && (body.description || body.message)) || 'cart add failed');
                err.payload = body;
                throw err;
              }
              return body;
            });
          });
        }
        if (!line) return cart;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        }).then(function (r) {
          return r.json();
        });
      });
  }

  function initCartDrawer() {
    document.addEventListener('click', function (e) {
      var resumoToggle = e.target.closest('[data-mco-resumo-toggle]');
      if (resumoToggle) {
        e.preventDefault();
        var resumo = resumoToggle.closest('[data-mco-cart-resumo]') || qs('#mco-cart-drawer-resumo');
        if (!resumo) return;
        var body = qs('.cart-drawer-resumo-body', resumo) || qs('#mco-cart-resumo-body', resumo);
        var open = resumo.classList.contains('is-collapsed');
        resumo.classList.toggle('is-collapsed', !open);
        resumoToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (body) {
          body.removeAttribute('hidden');
          body.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
        return;
      }

      var toggle = e.target.closest('.cart-drawer-attr-toggle');
      if (toggle) {
        e.preventDefault();
        var wrap = toggle.closest('.cart-drawer-product-attributes-wrap');
        if (!wrap) return;
        var extra = wrap.querySelector('.cart-drawer-attr-extra');
        if (!extra) return;
        var open = extra.hasAttribute('hidden');
        if (open) {
          extra.removeAttribute('hidden');
          toggle.textContent = toggle.getAttribute('data-label-less') || 'Ver menos';
        } else {
          extra.setAttribute('hidden', '');
          toggle.textContent = toggle.getAttribute('data-label-more') || 'Ver todos atributos';
        }
        return;
      }

      var qtyBtn = e.target.closest('[data-mco-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute('data-key');
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        if (!key && !line) return;
        var drawer = qs('#mco-cart-drawer-milano');
        if (drawer) drawer.classList.add('is-loading');
        changeCartLine(key || line, Math.max(0, qty))
          .then(function () {
            return refreshCartDrawer();
          })
          .catch(function () {
            if (drawer) drawer.classList.remove('is-loading');
          });
        return;
      }

      var giftBtn = e.target.closest('[data-mco-gift-bag]');
      if (giftBtn) {
        e.preventDefault();
        var on = giftBtn.getAttribute('data-gift-bag') !== '1';
        var variantId = giftBtn.getAttribute('data-gift-variant');
        giftBtn.classList.add('loading');
        setGiftBagAttribute(on, variantId)
          .then(function () {
            return refreshCartDrawer();
          })
          .catch(function () {
            window.alert('Não foi possível atualizar a Gift Bag.');
          })
          .finally(function () {
            giftBtn.classList.remove('loading');
          });
        return;
      }

      var couponRemoveBtn = e.target.closest('[data-mco-cart-coupon-remove]');
      if (couponRemoveBtn) {
        e.preventDefault();
        e.stopPropagation();
        setCouponNotice('');
        couponRemoveBtn.classList.add('loading');
        couponRemoveBtn.disabled = true;
        removeCartCoupon()
          .then(function () {
            return refreshCartDrawer({
              expandResumo: true,
              noticeHtml:
                '<p class="cart-drawer-coupon-notice cart-drawer-coupon-notice--ok">Cupom removido.</p>',
            });
          })
          .catch(function () {
            setCouponNotice(
              '<p class="cart-drawer-coupon-notice cart-drawer-coupon-notice--error">Não foi possível remover o cupom.</p>',
              true
            );
            if (isCartDrawerOpen()) keepCartDrawerOpen();
          })
          .finally(function () {
            var btn = qs('[data-mco-cart-coupon-remove]');
            if (btn) {
              btn.classList.remove('loading');
              btn.disabled = false;
            }
          });
        return;
      }
    });

    document.addEventListener('submit', function (e) {
      var couponForm = e.target.closest('[data-mco-cart-coupon]');
      if (!couponForm) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      var input =
        qs('#mco-cart-coupon-input', couponForm) || couponForm.querySelector('input[name="coupon_code"]');
      var code = input ? String(input.value || '').trim() : '';
      if (!code) {
        setCouponNotice(
          '<p class="cart-drawer-coupon-notice cart-drawer-coupon-notice--error">Informe um cupom.</p>',
          true
        );
        if (isCartDrawerOpen()) keepCartDrawerOpen();
        return;
      }

      var btn = couponForm.querySelector('.cart-drawer-coupon-btn');
      if (btn) {
        btn.classList.add('loading');
        btn.disabled = true;
      }
      setCouponNotice('');

      applyCartCouponCode(code)
        .then(function () {
          return refreshCartDrawer({
            expandResumo: true,
            noticeHtml:
              '<p class="cart-drawer-coupon-notice cart-drawer-coupon-notice--ok">Cupom aplicado com sucesso.</p>',
          });
        })
        .catch(function () {
          setCouponNotice(
            '<p class="cart-drawer-coupon-notice cart-drawer-coupon-notice--error">Cupom inválido ou não aplicável.</p>',
            true
          );
          if (isCartDrawerOpen()) keepCartDrawerOpen();
        })
        .finally(function () {
          var liveBtn = qs('.cart-drawer-coupon-btn');
          if (liveBtn) {
            liveBtn.classList.remove('loading');
            liveBtn.disabled = false;
          } else if (btn) {
            btn.classList.remove('loading');
            btn.disabled = false;
          }
        });
    });

    /* Open cart after discount redirect */
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('open_cart') === '1') {
        refreshCartDrawer().then(function () {
          openDrawer('mco-cart-drawer-milano');
        });
        if (window.history && window.history.replaceState) {
          params.delete('open_cart');
          var q = params.toString();
          window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
        }
      }
    } catch (err) {}

    /* On the standalone /cart page, keep the order summary expanded by default */
    if (qs('[data-mco-cart-page]')) {
      setCartResumoExpanded(true);
    }
  }

  /* ---- Footer lead + mobile collapsibles ---- */
  function initFooter() {
    var leadForm = qs('#mco-footer-lead-form');
    if (leadForm) {
      leadForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = (qs('#mco-footer-lead-name') || {}).value || '';
        var wa = (qs('#mco-footer-lead-wa') || {}).value || '';
        var err = qs('#mco-footer-lead-error');
        var ok = qs('#mco-footer-lead-success');
        if (err) err.hidden = true;
        if (ok) ok.hidden = true;
        if (!name.trim() || !wa.trim()) {
          if (err) {
            err.hidden = false;
            err.textContent = 'Preencha nome e WhatsApp.';
          }
          return;
        }
        writeBenefitsLead({ name: name.trim(), wa: wa.trim(), at: Date.now(), coupon: COUPON_CODE });
        try {
          sessionStorage.setItem('mco_coupon', COUPON_CODE);
        } catch (err2) {}
        applyCoupon(COUPON_CODE).finally(function () {
          if (ok) ok.hidden = false;
          var fab = qs('#mco-benefits-fab');
          if (fab) {
            fab.classList.add('is-visible');
            startBenefitsTimer(fab);
          }
          scheduleSamaraTooltip(true);
        });
      });
    }

    var mq = window.matchMedia('(max-width: 989px)');

    function closeCol(col) {
      var panel = qs('[data-mco-footer-panel]', col);
      var btn = qs('[data-mco-footer-toggle]', col);
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      panel.offsetHeight;
      panel.style.height = '0px';
      col.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    function openCol(col) {
      var panel = qs('[data-mco-footer-panel]', col);
      var btn = qs('[data-mco-footer-toggle]', col);
      if (!panel) return;
      col.classList.add('is-open');
      panel.style.height = panel.scrollHeight + 'px';
      if (btn) btn.setAttribute('aria-expanded', 'true');
      var onEnd = function (ev) {
        if (ev.propertyName !== 'height') return;
        if (col.classList.contains('is-open')) panel.style.height = 'auto';
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
    }

    function resetDesktop() {
      qsa('[data-mco-footer-col]').forEach(function (col) {
        var panel = qs('[data-mco-footer-panel]', col);
        var btn = qs('[data-mco-footer-toggle]', col);
        col.classList.remove('is-open');
        if (panel) panel.style.height = '';
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function resetMobile() {
      qsa('[data-mco-footer-col]').forEach(function (col) {
        var panel = qs('[data-mco-footer-panel]', col);
        var btn = qs('[data-mco-footer-toggle]', col);
        if (col.hasAttribute('data-mco-footer-always-open')) {
          col.classList.add('is-open');
          if (panel) panel.style.height = 'auto';
          if (btn) btn.setAttribute('aria-expanded', 'true');
          return;
        }
        col.classList.remove('is-open');
        if (panel) panel.style.height = '0px';
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mco-footer-toggle]');
      if (!btn || !mq.matches) return;
      e.preventDefault();
      var col = btn.closest('[data-mco-footer-col]');
      if (!col || col.hasAttribute('data-mco-footer-always-open')) return;
      if (col.classList.contains('is-open')) closeCol(col);
      else openCol(col);
    });

    function onMqChange() {
      if (mq.matches) resetMobile();
      else resetDesktop();
    }
    if (mq.addEventListener) mq.addEventListener('change', onMqChange);
    else if (mq.addListener) mq.addListener(onMqChange);
    onMqChange();
  }

  /* ---- Header hide on scroll down / show on scroll up ---- */
  function initChromeScroll() {
    var chrome = qs('#mco-chrome');
    if (!chrome) return;
    var lastY = window.scrollY || 0;
    var ticking = false;
    var threshold = 8;
    var root = document.documentElement;

    function syncChromeHiddenClass() {
      root.classList.toggle('mco-chrome-hidden', chrome.classList.contains('is-hidden'));
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY || window.pageYOffset || 0;
          var delta = y - lastY;
          if (y <= 10) {
            chrome.classList.remove('is-hidden');
          } else if (delta > threshold) {
            chrome.classList.add('is-hidden');
          } else if (delta < -threshold) {
            chrome.classList.remove('is-hidden');
          }
          syncChromeHiddenClass();
          lastY = y;
          ticking = false;
        });
      },
      { passive: true }
    );

    syncChromeHiddenClass();
  }

  /* ---- Product grid / PDP 2x square loupe (desktop only) ---- */
  function initGridLoupe() {
    if (qs('.mco-grid-loupe')) return;

    var loupe = document.createElement('div');
    loupe.className = 'mco-grid-loupe';
    loupe.setAttribute('aria-hidden', 'true');
    document.body.appendChild(loupe);

    var size = 140;
    var zoom = 2;
    var activeImg = null;
    var mq = window.matchMedia('(min-width: 990px)');
    var imgSelector =
      '.novidades-card-slide.is-active img, .mco-card__slide.is-active img, .search-product-image img, .mco-pdp__main-image, .mco-pdp__zoom-trigger img';

    function resolveLoupeImg(target) {
      if (!target || !target.closest) return null;
      if (
        target.closest(
          '[data-mco-card-nav], .mco-card__nav, .mco-card__dot, .novidades-card-dot, [data-mco-card-atc], .mco-card__atc, .mco-card__image-badges'
        )
      ) {
        return null;
      }
      var activeSlide = target.closest('.novidades-card-slide.is-active, .mco-card__slide.is-active');
      if (activeSlide) return qs('img', activeSlide);
      var slide = target.closest('.novidades-card-slide, .mco-card__slide');
      if (slide && !slide.classList.contains('is-active')) return null;
      return target.closest(imgSelector);
    }

    function hide() {
      activeImg = null;
      loupe.style.display = 'none';
      document.body.classList.remove('mco-loupe-active');
    }

    function getLoupeBackground(img, clientX, clientY) {
      var rect = img.getBoundingClientRect();
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      var x = clientX - rect.left;
      var y = clientY - rect.top;

      if (!nw || !nh) {
        return {
          size: rect.width * zoom + 'px ' + rect.height * zoom + 'px',
          pos: -(x * zoom - size / 2) + 'px ' + -(y * zoom - size / 2) + 'px',
        };
      }

      var fit = window.getComputedStyle(img).objectFit || 'fill';
      var scale;
      var renderedW;
      var renderedH;
      var offsetX;
      var offsetY;

      if (fit === 'cover') {
        scale = Math.max(rect.width / nw, rect.height / nh);
        renderedW = nw * scale;
        renderedH = nh * scale;
        offsetX = (rect.width - renderedW) / 2;
        offsetY = (rect.height - renderedH) / 2;
      } else if (fit === 'contain' || fit === 'none' || fit === 'scale-down') {
        scale = Math.min(rect.width / nw, rect.height / nh);
        renderedW = nw * scale;
        renderedH = nh * scale;
        offsetX = (rect.width - renderedW) / 2;
        offsetY = (rect.height - renderedH) / 2;
      } else {
        var scaleX = rect.width / nw;
        var scaleY = rect.height / nh;
        if (Math.abs(scaleX - scaleY) < 0.02) {
          renderedW = rect.width;
          renderedH = rect.height;
          offsetX = 0;
          offsetY = 0;
        } else {
          scale = Math.min(scaleX, scaleY);
          renderedW = nw * scale;
          renderedH = nh * scale;
          offsetX = (rect.width - renderedW) / 2;
          offsetY = (rect.height - renderedH) / 2;
        }
      }

      var rx = x - offsetX;
      var ry = y - offsetY;

      return {
        size: renderedW * zoom + 'px ' + renderedH * zoom + 'px',
        pos: -(rx * zoom - size / 2) + 'px ' + -(ry * zoom - size / 2) + 'px',
      };
    }

    function onMove(e) {
      if (!mq.matches || !activeImg) return;
      var rect = activeImg.getBoundingClientRect();
      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        hide();
        return;
      }
      var bg = getLoupeBackground(activeImg, e.clientX, e.clientY);
      loupe.style.display = 'block';
      document.body.classList.add('mco-loupe-active');
      loupe.style.left = e.clientX - size / 2 + 'px';
      loupe.style.top = e.clientY - size / 2 + 'px';
      loupe.style.backgroundImage = 'url("' + (activeImg.currentSrc || activeImg.src) + '")';
      loupe.style.backgroundSize = bg.size;
      loupe.style.backgroundPosition = bg.pos;
    }

    document.addEventListener('mouseover', function (e) {
      if (!mq.matches) return;
      var img = resolveLoupeImg(e.target);
      if (!img) return;
      activeImg = img;
    });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseout', function (e) {
      if (!activeImg) return;
      if (e.relatedTarget && activeImg.contains && activeImg.contains(e.relatedTarget)) return;
      var next = resolveLoupeImg(e.relatedTarget);
      if (next) {
        activeImg = next;
        return;
      }
      hide();
    });
  }

  /* ---- Related products: pagination + skeleton ---- */
  function getRelatedCols() {
    return window.matchMedia('(min-width: 990px)').matches ? 6 : 2;
  }

  function shuffleRelatedProducts(grid) {
    if (!grid || grid.getAttribute('data-mco-related-shuffled') === '1') return;

    var primary = [];
    var fallback = [];
    qsa('.search-product-card, .mco-card', grid).forEach(function (card) {
      if (card.getAttribute('data-mco-related-priority') === 'primary') primary.push(card);
      else fallback.push(card);
    });

    function shuffle(cards) {
      for (var i = cards.length - 1; i > 0; i -= 1) {
        var randomIndex = Math.floor(Math.random() * (i + 1));
        var current = cards[i];
        cards[i] = cards[randomIndex];
        cards[randomIndex] = current;
      }
    }

    shuffle(primary);
    shuffle(fallback);
    primary.concat(fallback).forEach(function (card) {
      grid.appendChild(card);
    });
    grid.setAttribute('data-mco-related-shuffled', '1');
  }

  function applyRelatedPagination(root, opts) {
    if (!root) return;
    var options = opts || {};
    var isLoadMore = !!options.loadMore;
    var grid = qs('[data-mco-related-grid]', root) || qs('#related-products-grid', root);
    var moreBtn = qs('[data-mco-related-more]', root);
    var skeleton = isLoadMore
      ? qs('[data-mco-related-more-skeleton]', root) || qs('[data-mco-related-skeleton]', root)
      : qs('[data-mco-related-skeleton]', root);
    if (!grid) return;

    var scrollY = window.scrollY || window.pageYOffset || 0;
    var cards = qsa('.search-product-card, .mco-card', grid);
    var cols = getRelatedCols();
    var rawPageSize = parseInt(root.getAttribute('data-page-size') || String(cols), 10) || cols;
    /* Always step by full rows (6 on desktop / 2 on mobile) so grids never leave an empty slot */
    var pageSize = Math.max(cols, Math.floor(rawPageSize / cols) * cols);
    if (pageSize < cols) pageSize = cols;
    if (pageSize % 2 !== 0 && cols === 2) pageSize = Math.max(2, pageSize - 1);
    var page = parseInt(root.getAttribute('data-page') || '1', 10) || 1;
    var visibleLimit = page * pageSize;
    var prevVisible = isLoadMore ? Math.floor(((page - 1) * pageSize) / cols) * cols : 0;

    if (cards.length >= cols) {
      visibleLimit = Math.floor(visibleLimit / cols) * cols;
      if (visibleLimit < cols) visibleLimit = cols;
      if (visibleLimit > cards.length) {
        visibleLimit = Math.floor(cards.length / cols) * cols;
        if (visibleLimit < cols && cards.length >= cols) visibleLimit = cols;
      }
    } else {
      /* Prefer even count on 2-col layouts when fewer than a full row exist */
      visibleLimit = cols === 2 ? cards.length - (cards.length % 2) : cards.length;
      if (visibleLimit < 1 && cards.length) visibleLimit = cards.length;
    }

    if (isLoadMore) {
      root.classList.add('is-loading-more');
      if (skeleton) {
        skeleton.hidden = false;
        skeleton.setAttribute('aria-hidden', 'false');
      }
    }

    cards.forEach(function (card, idx) {
      var show = idx < visibleLimit;
      card.classList.toggle('is-page-hidden', !show);
      if (isLoadMore && show && idx >= prevVisible) {
        card.classList.add('novidades-card-reveal');
      }
    });

    if (moreBtn) {
      var nextEvenOrRow = Math.floor(cards.length / cols) * cols;
      if (cards.length < 1) {
        setLoadMoreButtonState(moreBtn, false, { hideWhenEmpty: true });
      } else {
        setLoadMoreButtonState(moreBtn, nextEvenOrRow > visibleLimit);
      }
    }

    root.classList.add('is-loaded');
    initCardSlideshow(grid);

    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
    });

    window.setTimeout(function () {
      root.classList.remove('is-loading-more');
      if (skeleton) {
        skeleton.hidden = true;
        skeleton.setAttribute('aria-hidden', 'true');
      }
      window.scrollTo(0, scrollY);
    }, isLoadMore ? 280 : 0);
  }

  function bindRelatedMore(root) {
    var moreBtn = qs('[data-mco-related-more]', root);
    if (!moreBtn || moreBtn._mcoBound) return;
    moreBtn._mcoBound = true;
    moreBtn.addEventListener('click', function () {
      if (moreBtn.disabled || moreBtn.classList.contains('is-end')) return;
      var page = parseInt(root.getAttribute('data-page') || '1', 10) + 1;
      root.setAttribute('data-page', String(page));
      if (hasActiveFilters()) applyNovidadesFilters(false);
      else applyRelatedPagination(root, { loadMore: true });
    });
  }

  function initRelatedProductsGrid() {
    var root = qs('[data-mco-related]');
    if (!root || root._mcoRelatedInit) return;
    root._mcoRelatedInit = true;

    function onReady() {
      var grid = qs('[data-mco-related-grid]', root) || qs('#related-products-grid', root);
      if (!grid) return;
      bindRelatedMore(root);
      shuffleRelatedProducts(grid);
      applyRelatedPagination(root);
    }

    bindRelatedMore(root);
    onReady();
    initRelatedStickyFilters(root);

    var colsMq = window.matchMedia('(min-width: 990px)');
    var onColsChange = function () {
      root.setAttribute('data-page', '1');
      if (hasActiveFilters()) applyNovidadesFilters(true);
      else applyRelatedPagination(root);
    };
    if (colsMq.addEventListener) colsMq.addEventListener('change', onColsChange);
    else if (colsMq.addListener) colsMq.addListener(onColsChange);
  }

  function initRelatedStickyFilters(root) {
    initStickyFilterBars(root);
  }

  function initStickyFilterBars(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var bars = qsa('.novidades-filters-full-width', root);
    if (!bars.length && root && root.matches && root.matches('.novidades-filters-full-width')) {
      bars = [root];
    }

    bars.forEach(function (bar) {
      if (!bar || bar._mcoStuckInit) return;
      bar._mcoStuckInit = true;
      bar.classList.remove('is-stuck');

      var sentinel = bar.previousElementSibling;
      if (!sentinel || !sentinel.classList.contains('mco-related-sticky-sentinel')) {
        sentinel = document.createElement('div');
        sentinel.className = 'mco-related-sticky-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        if (bar.parentNode) bar.parentNode.insertBefore(sentinel, bar);
      }

      function stickyTopPx() {
        var raw = window.getComputedStyle(bar).top || '0';
        var n = parseFloat(raw);
        return isNaN(n) ? 0 : n;
      }

      function syncStuck() {
        var top = stickyTopPx();
        var rect = sentinel.getBoundingClientRect();
        bar.classList.toggle('is-stuck', rect.bottom <= top + 1);
      }

      if (typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(
          function () {
            syncStuck();
          },
          { threshold: [0, 1] }
        );
        observer.observe(sentinel);
      }

      window.addEventListener('scroll', syncStuck, { passive: true });
      window.addEventListener('resize', syncStuck);
      syncStuck();
    });
  }

  function addRelatedCardToCart(btn) {
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');

    addToCartAndOpenDrawer(fd)
      .catch(function (err) {
        console.error('[Milano] related card add to cart failed', err);
        var msg =
          (err && err.payload && (err.payload.description || err.payload.message)) ||
          'Não foi possível adicionar ao carrinho.';
        window.alert(msg);
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---- Cart coupon banner timer (cookie + IP) ---- */
  var CART_COUPON_MS = 10 * 60 * 1000;
  var CART_COUPON_COOKIE = 'mco_cart_coupons_v1';
  var cartCouponTimerId = null;

  function readCookie(name) {
    if (!name) return '';
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + String(name).replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, maxAgeSec) {
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAgeSec +
      '; SameSite=Lax';
  }

  function readCouponStore() {
    var raw = '';
    try {
      raw = localStorage.getItem(CART_COUPON_COOKIE) || '';
    } catch (err) {}
    if (!raw) raw = readCookie(CART_COUPON_COOKIE);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err2) {
      return null;
    }
  }

  function writeCouponStore(data) {
    var raw = JSON.stringify(data);
    try {
      localStorage.setItem(CART_COUPON_COOKIE, raw);
    } catch (err) {}
    var maxAge = 60 * 60 * 24;
    if (data.end) maxAge = Math.max(60, Math.ceil((data.end - Date.now()) / 1000) + 60);
    if (data.done) maxAge = 60 * 60 * 24;
    writeCookie(CART_COUPON_COOKIE, raw, maxAge);
  }

  function clearCouponStore() {
    /* Keep a done marker so the banner does not restart on refresh */
    var prev = readCouponStore() || {};
    writeCouponStore({ done: true, ip: prev.ip || '', ended: Date.now() });
  }

  function fetchVisitorIp() {
    return fetch('https://api.ipify.org?format=json')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        return (data && data.ip) || '';
      })
      .catch(function () {
        return '';
      });
  }

  function formatCouponTimer(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + String(s).padStart(2, '0');
  }

  function updateCartCouponTimers(text) {
    qsa('[data-mco-cart-coupon-timer]').forEach(function (el) {
      var prefix = el.getAttribute('data-mco-cart-coupon-timer-prefix') || '';
      el.textContent = prefix + text;
    });
  }

  function setCartCouponTimerVisibility(visible) {
    qsa('[data-mco-cart-coupon-timer]').forEach(function (el) {
      if (el.closest('[data-mco-cart-coupons]')) return;
      el.hidden = !visible;
    });
  }

  function initCartCouponBanner() {
    var banner = qs('[data-mco-cart-coupons]');
    if (!banner) return;
    clearInterval(cartCouponTimerId);
    cartCouponTimerId = null;
    var couponEnd = 0;

    function hideBanner() {
      banner.hidden = true;
      clearInterval(cartCouponTimerId);
      cartCouponTimerId = null;
      clearCouponStore();
      setCartCouponTimerVisibility(false);
    }

    function tick() {
      var left = couponEnd - Date.now();
      if (left <= 0) {
        hideBanner();
        return;
      }
      updateCartCouponTimers(formatCouponTimer(left));
      banner.hidden = false;
      setCartCouponTimerVisibility(true);
    }

    function syncCouponTimer() {
      var visible =
        !banner.hidden &&
        !document.hidden &&
        banner.offsetParent !== null &&
        banner.getBoundingClientRect().height > 0;
      if (visible && couponEnd > Date.now()) {
        tick();
        if (!cartCouponTimerId) cartCouponTimerId = setInterval(tick, 1000);
      } else if (cartCouponTimerId) {
        clearInterval(cartCouponTimerId);
        cartCouponTimerId = null;
      }
    }

    function startWithEnd(end) {
      couponEnd = end;
      tick();
      syncCouponTimer();
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function () {
          syncCouponTimer();
        }, { threshold: 0.01 });
        io.observe(banner);
      }
      document.addEventListener('visibilitychange', syncCouponTimer);
    }

    fetchVisitorIp().then(function (ip) {
      var store = readCouponStore();
      var now = Date.now();
      if (store && store.done) {
        hideBanner();
        return;
      }
      if (store && store.end && store.end > now) {
        if (!store.ip || !ip || store.ip === ip) {
          startWithEnd(store.end);
          return;
        }
      }
      if (store && store.end && store.end <= now) {
        writeCouponStore({ done: true, ip: ip || '', ended: store.end });
        hideBanner();
        return;
      }
      var end = now + CART_COUPON_MS;
      writeCouponStore({ end: end, ip: ip || '', started: now });
      startWithEnd(end);
    });
  }

  function initHeroTopBanner() {
    var banners = qsa('[data-mco-hero-top-banner]');
    if (!banners.length) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    banners.forEach(function (wrap) {
      var video = qs('video', wrap);
      if (!video) return;
      var src = video.getAttribute('data-src');
      if (!src) return;

      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      if (!video.getAttribute('src') && !qs('source', video)) {
        video.src = src;
        video.load();
      }

      function tryPlay() {
        video.loop = true;
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.catch(function () {
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      }

      function restartLoop() {
        try {
          video.currentTime = 0;
        } catch (err) {}
        tryPlay();
      }

      video.addEventListener('ended', restartLoop);
      video.addEventListener('pause', function () {
        if (document.hidden) return;
        if (video.ended || (video.duration > 0 && video.currentTime >= video.duration - 0.05)) {
          restartLoop();
        }
      });
      video.addEventListener('timeupdate', function () {
        if (!video.duration || !isFinite(video.duration)) return;
        if (video.duration - video.currentTime < 0.08) restartLoop();
      });

      if (video.readyState >= 2) tryPlay();
      else video.addEventListener('canplay', tryPlay, { once: true });
      tryPlay();
    });
  }

  function initHeroVideoDeferred() {
    var heroes = qsa('[data-mco-hero]');
    if (!heroes.length) return;
    /* Mobile: static background only — never load/play hero video */
    if (window.matchMedia('(max-width: 749px)').matches) return;

    function activateHero(hero) {
      if (!hero || hero.getAttribute('data-mco-hero-ready') === '1') return;
      var slot = qs('[data-mco-hero-video-slot]', hero);
      if (!slot) return;
      hero.setAttribute('data-mco-hero-ready', '1');
      slot.hidden = false;
      slot.removeAttribute('hidden');
      slot.classList.add('is-active');

      var video = qs('video', slot);
      if (video) {
        var deferredSrc = video.getAttribute('data-mco-hero-video-src');
        if (deferredSrc && !video.getAttribute('src') && !qs('source', video)) {
          var source = document.createElement('source');
          source.src = deferredSrc;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.removeAttribute('data-mco-hero-video-src');
        }
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(function () {
              hero.classList.add('is-video-ready');
            })
            .catch(function () {});
        } else {
          hero.classList.add('is-video-ready');
        }
        video.addEventListener(
          'playing',
          function () {
            hero.classList.add('is-video-ready');
          },
          { once: true }
        );
      } else {
        hero.classList.add('is-video-ready');
      }
    }

    function schedule(hero) {
      var run = function () {
        activateHero(hero);
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1800 });
      } else {
        setTimeout(run, 900);
      }
    }

    heroes.forEach(function (hero) {
      if (!qs('[data-mco-hero-video-slot]', hero)) return;
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              io.disconnect();
              schedule(hero);
            });
          },
          { rootMargin: '100px', threshold: 0.01 }
        );
        io.observe(hero);
      } else {
        schedule(hero);
      }
    });
  }

  function initFaq() {
    qsa('[data-mco-faq]').forEach(function (root) {
      var searchInput = qs('[data-mco-faq-search]', root);
      var pills = qsa('[data-mco-faq-filter]', root);
      var items = qsa('[data-mco-faq-item]', root);
      var empty = qs('[data-mco-faq-empty]', root);
      var activeFilter = 'all';

      function applyFilters() {
        var query = searchInput ? String(searchInput.value || '').trim().toLowerCase() : '';
        var visible = 0;

        items.forEach(function (item) {
          var category = item.getAttribute('data-category') || '';
          var haystack = item.getAttribute('data-search') || '';
          var matchesCategory = activeFilter === 'all' || category === activeFilter;
          var matchesSearch = !query || haystack.indexOf(query) !== -1;
          var show = matchesCategory && matchesSearch;
          item.classList.toggle('is-hidden', !show);
          if (show) visible += 1;
          if (!show) {
            var btn = qs('[data-mco-faq-toggle]', item);
            var panel = qs('.mco-faq__panel', item);
            if (btn && panel && btn.getAttribute('aria-expanded') === 'true') {
              btn.setAttribute('aria-expanded', 'false');
              panel.hidden = true;
            }
          }
        });

        if (empty) empty.hidden = visible > 0;
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          activeFilter = pill.getAttribute('data-mco-faq-filter') || 'all';
          pills.forEach(function (p) {
            var on = p === pill;
            p.classList.toggle('is-active', on);
            p.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          applyFilters();
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', applyFilters);
      }

      qsa('[data-mco-faq-toggle]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-mco-faq-item]');
          if (!item) return;
          var panel = qs('.mco-faq__panel', item);
          if (!panel) return;
          var willOpen = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          panel.hidden = !willOpen;
        });
      });
    });
  }

  function initMenuSearch() {
    var root = qs('[data-mco-menu-search]');
    if (!root) return;
    var input = qs('[data-mco-menu-search-input]', root);
    var dropdown = qs('[data-mco-menu-search-dropdown]', root);
    var results = qs('[data-mco-menu-search-results]', root);
    var clearBtn = qs('[data-mco-menu-search-clear]', root);
    var recentWrap = qs('[data-mco-menu-search-recent]', root);
    var pillsWrap = qs('[data-mco-menu-search-pills]', root);
    var historyClearBtn = qs('[data-mco-menu-search-history-clear]', root);
    if (!input || !dropdown || !results) return;

    var RECENT_KEY = 'mco_recent_searches';
    var RECENT_MAX = 8;
    var timer = null;
    var abortController = null;
    var cache = {};
    var suggestUrl =
      (window.routes && window.routes.predictive_search_url) || '/search/suggest';

    function readRecent() {
      try {
        var raw = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(raw)
          ? raw
              .map(function (t) {
                return String(t || '').trim();
              })
              .filter(Boolean)
          : [];
      } catch (e) {
        return [];
      }
    }

    function writeRecent(items) {
      try {
        localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, RECENT_MAX)));
      } catch (e) {}
    }

    function saveRecent(term) {
      var t = String(term || '').trim();
      if (!t) return;
      var items = readRecent().filter(function (x) {
        return x.toLowerCase() !== t.toLowerCase();
      });
      items.unshift(t);
      writeRecent(items);
      renderRecent();
    }

    function clearRecentHistory() {
      writeRecent([]);
      renderRecent();
      syncDropdownVisibility();
    }

    function renderRecent() {
      if (!recentWrap || !pillsWrap) return;
      var items = readRecent();
      pillsWrap.innerHTML = '';
      if (!items.length) {
        recentWrap.hidden = true;
        return;
      }
      recentWrap.hidden = false;
      items.forEach(function (term) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mco-menu-search__pill';
        btn.textContent = term;
        btn.setAttribute('data-mco-menu-search-pill', term);
        pillsWrap.appendChild(btn);
      });
    }

    function syncClearBtn() {
      if (!clearBtn) return;
      clearBtn.hidden = !input.value.length;
    }

    function hasDropdownContent() {
      var hasRecent = recentWrap && !recentWrap.hidden && readRecent().length > 0;
      var hasResults = !!results.querySelector('.mco-menu-search__item, .mco-menu-search__empty');
      return hasRecent || hasResults;
    }

    function openDropdown() {
      renderRecent();
      if (!hasDropdownContent()) {
        closeDropdown();
        return;
      }
      dropdown.hidden = false;
      dropdown.setAttribute('aria-hidden', 'false');
      input.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.hidden = true;
      dropdown.setAttribute('aria-hidden', 'true');
      input.setAttribute('aria-expanded', 'false');
    }

    function syncDropdownVisibility() {
      if (document.activeElement === input || root.contains(document.activeElement)) {
        openDropdown();
      } else if (!input.value.trim()) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    function clearResultsOnly() {
      results.innerHTML = '';
    }

    function renderMarkup(markup) {
      results.innerHTML = markup || '';
      openDropdown();
    }

    function runSearch(term) {
      var key = term.toLowerCase();
      if (cache[key]) {
        renderMarkup(cache[key]);
        return;
      }
      if (abortController) abortController.abort();
      abortController = new AbortController();

      var url =
        suggestUrl +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,page,article,collection' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&section_id=milano-menu-predictive-search';

      fetch(url, { signal: abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-milano-menu-predictive-search');
          var markup = section ? section.innerHTML : '';
          cache[key] = markup;
          if (input.value.trim().toLowerCase() === key) {
            renderMarkup(markup);
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          clearResultsOnly();
          openDropdown();
        });
    }

    function applyTerm(term, doSearch) {
      input.value = term;
      syncClearBtn();
      if (!term) {
        clearResultsOnly();
        openDropdown();
        return;
      }
      saveRecent(term);
      if (doSearch) runSearch(term);
      else openDropdown();
    }

    input.addEventListener('focus', function () {
      renderRecent();
      openDropdown();
      if (input.value.trim()) runSearch(input.value.trim());
    });

    input.addEventListener('input', function () {
      var term = input.value.trim();
      syncClearBtn();
      window.clearTimeout(timer);
      if (!term) {
        if (abortController) abortController.abort();
        clearResultsOnly();
        openDropdown();
        return;
      }
      timer = window.setTimeout(function () {
        runSearch(term);
      }, 200);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDropdown();
        input.blur();
      } else if (e.key === 'Enter') {
        var term = input.value.trim();
        if (term) saveRecent(term);
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        syncClearBtn();
        clearResultsOnly();
        renderRecent();
        openDropdown();
        input.focus();
      });
    }

    if (historyClearBtn) {
      historyClearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearRecentHistory();
      });
    }

    if (pillsWrap) {
      pillsWrap.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-mco-menu-search-pill]');
        if (!pill) return;
        e.preventDefault();
        applyTerm(pill.getAttribute('data-mco-menu-search-pill') || pill.textContent, true);
        input.focus();
      });
    }

    results.addEventListener('click', function (e) {
      var link = e.target.closest('a.mco-menu-search__item');
      if (!link) return;
      var term = input.value.trim();
      if (term) saveRecent(term);
      closeDrawers();
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeDropdown();
    });

    renderRecent();
    syncClearBtn();
  }

  function initMenuLocale() {
    var form = qs('#McoMenuLocaleForm');
    if (!form) return;

    var langSelect = qs('[data-mco-locale-language]', form);
    var currencySelect = qs('[data-mco-locale-currency]', form);
    var localeHidden = qs('[data-mco-locale-code]', form);
    var countryHidden = qs('[data-mco-country-code]', form);

    function syncHiddenFields() {
      if (langSelect && localeHidden) localeHidden.value = langSelect.value;
      if (currencySelect && countryHidden) countryHidden.value = currencySelect.value;
    }

    function autofillCurrencyFromLanguage() {
      if (!langSelect || !currencySelect) return;
      var option = langSelect.options[langSelect.selectedIndex];
      var defaultCurrency = option && option.getAttribute('data-default-currency');
      if (!defaultCurrency) return;
      for (var i = 0; i < currencySelect.options.length; i++) {
        if (currencySelect.options[i].getAttribute('data-currency') === defaultCurrency) {
          currencySelect.selectedIndex = i;
          break;
        }
      }
    }

    if (langSelect) {
      langSelect.addEventListener('change', function () {
        autofillCurrencyFromLanguage();
        syncHiddenFields();
      });
    }
    if (currencySelect) {
      currencySelect.addEventListener('change', syncHiddenFields);
    }
    syncHiddenFields();
  }

  function initAttrInfoTooltips() {
    var buttons = qsa('[data-mco-attr-info]');
    if (!buttons.length) return;

    var overflowParents = [];
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var ignoreDocCloseUntil = 0;

    function getTooltip(btn) {
      var wrap = btn.closest('.pdp-attr-value-wrap');
      return wrap ? qs('.pdp-attr-tooltip', wrap) : null;
    }

    function releaseOverflow() {
      overflowParents.forEach(function (el) {
        el.style.overflow = '';
      });
      overflowParents = [];
    }

    function allowOverflow(btn) {
      releaseOverflow();
      var panelInner = btn.closest('.mco-pdp__acc-panel-inner');
      if (panelInner) {
        panelInner.style.overflow = 'visible';
        overflowParents.push(panelInner);
      }
      var panel = btn.closest('.mco-pdp__acc-panel');
      if (panel) {
        panel.style.overflow = 'visible';
        overflowParents.push(panel);
      }
    }

    function closeAll(exceptBtn) {
      buttons.forEach(function (btn) {
        if (exceptBtn && btn === exceptBtn) return;
        btn.setAttribute('aria-expanded', 'false');
        var tip = getTooltip(btn);
        if (tip) tip.hidden = true;
      });
      if (!exceptBtn) releaseOverflow();
    }

    function openTip(btn) {
      closeAll(btn);
      var tip = getTooltip(btn);
      if (!tip) return;
      allowOverflow(btn);
      tip.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }

    function toggleTip(btn) {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        var tip = getTooltip(btn);
        if (tip) tip.hidden = true;
        releaseOverflow();
      } else {
        openTip(btn);
      }
    }

    buttons.forEach(function (btn) {
      // Touch/coarse: click-only toggle. Hover devices also get mouseenter/focus below.
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleTip(btn);
        ignoreDocCloseUntil = Date.now() + 400;
      });

      if (canHover) {
        btn.addEventListener('mouseenter', function () {
          openTip(btn);
        });

        btn.addEventListener('mouseleave', function () {
          if (document.activeElement !== btn) closeAll();
        });

        btn.addEventListener('focus', function () {
          openTip(btn);
        });

        btn.addEventListener('blur', function () {
          closeAll();
        });
      }
    });

    // Bubble phase so the opening tap is not closed by a capture listener first.
    document.addEventListener('click', function (e) {
      if (Date.now() < ignoreDocCloseUntil) return;
      if (e.target.closest('[data-mco-attr-info]') || e.target.closest('.pdp-attr-tooltip')) return;
      closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAll();
    });
  }

  function initPdpStories() {
    var root = qs('[data-mco-detalhes]');
    var story = qs('[data-mco-story]');
    if (!root || !story || root.getAttribute('data-mco-story-init') === '1') return;
    root.setAttribute('data-mco-story-init', '1');
    if (story.parentElement !== document.body) document.body.appendChild(story);

    var triggers = qsa('[data-mco-story-open]', root);
    if (!triggers.length) return;

    var video = qs('[data-mco-story-video]', story);
    var progress = qs('[data-mco-story-progress]', story);
    var closeBtn = qs('[data-mco-story-close]', story);
    var muteBtn = qs('[data-mco-story-mute]', story);
    var cta = qs('[data-mco-story-cta]', story);
    var waBtn = qs('[data-mco-story-wa]', story);
    var prevZone = qs('[data-mco-story-prev]', story);
    var nextZone = qs('[data-mco-story-next]', story);
    var loader = qs('[data-mco-story-loader]', story);
    var index = 0;
    var muted = true;
    var lastFocus = null;
    var pointer = null;
    var holdTimer = null;

    if (progress) {
      progress.innerHTML = '';
      triggers.forEach(function (_, i) {
        var bar = document.createElement('button');
        bar.type = 'button';
        bar.className = 'mco-story__bar';
        bar.setAttribute('aria-label', 'Vídeo ' + (i + 1));
        bar.innerHTML = '<span class="mco-story__bar-fill"></span>';
        bar.addEventListener('click', function () {
          show(i);
        });
        progress.appendChild(bar);
      });
    }

    function fills() {
      return progress ? qsa('.mco-story__bar-fill', progress) : [];
    }

    function wraps() {
      return progress ? qsa('.mco-story__bar', progress) : [];
    }

    function setProgress(amount) {
      var value = Math.max(0, Math.min(1, amount || 0));
      wraps().forEach(function (wrap, i) {
        wrap.classList.toggle('is-done', i < index);
        wrap.classList.toggle('is-current', i === index);
      });
      fills().forEach(function (fill, i) {
        var scale = 0;
        if (i < index) scale = 1;
        else if (i === index) scale = value;
        fill.style.transform = 'scaleX(' + scale + ')';
      });
    }

    function paintMute() {
      if (!muteBtn) return;
      muteBtn.setAttribute('aria-label', muted ? 'Ativar som' : 'Silenciar');
      muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      var on = qs('[data-icon="on"]', muteBtn);
      var off = qs('[data-icon="off"]', muteBtn);
      if (on) on.hidden = muted;
      if (off) off.hidden = !muted;
    }

    function playCurrent() {
      if (!video) return;
      video.muted = muted;
      var attempt = video.play();
      if (!attempt || !attempt.then) return;
      attempt.then(function () {
        if (loader) loader.hidden = true;
      }).catch(function () {
        if (!muted) {
          muted = true;
          video.muted = true;
          paintMute();
          video.play().catch(function () {});
        }
      });
    }

    function show(nextIndex) {
      if (nextIndex < 0) {
        if (video) {
          video.currentTime = 0;
          playCurrent();
        }
        return;
      }
      if (nextIndex >= triggers.length) {
        closeStory();
        return;
      }
      index = nextIndex;
      var btn = triggers[index];
      btn.classList.add('is-seen');
      var src = btn.getAttribute('data-src') || '';
      var poster = btn.getAttribute('data-poster') || '';
      if (!video || !src) return;
      if (loader) loader.hidden = false;
      video.poster = poster;
      if (video.getAttribute('src') !== src) {
        video.setAttribute('src', src);
        video.load();
      } else {
        try {
          video.currentTime = 0;
        } catch (err) {}
      }
      setProgress(0);
      playCurrent();
    }

    function openStory(startIndex) {
      lastFocus = document.activeElement;
      story.hidden = false;
      story.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mco-story-open');
      show(startIndex);
      if (closeBtn) closeBtn.focus();
    }

    function closeStory() {
      if (story.hidden) return;
      story.hidden = true;
      story.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mco-story-open');
      if (video) video.pause();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (video) {
      video.addEventListener('timeupdate', function () {
        if (!video.duration || story.hidden) return;
        setProgress(video.currentTime / video.duration);
      });
      video.addEventListener('playing', function () {
        if (loader) loader.hidden = true;
      });
      video.addEventListener('waiting', function () {
        if (loader) loader.hidden = false;
      });
      video.addEventListener('ended', function () {
        if (index < triggers.length - 1) show(index + 1);
        else setProgress(1);
      });
    }

    triggers.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        openStory(i);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeStory);
    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        muted = !muted;
        if (video) video.muted = muted;
        paintMute();
      });
    }
    if (cta) {
      cta.addEventListener('click', function () {
        closeStory();
        var targetSel = story.getAttribute('data-scroll-target');
        var target = targetSel ? document.querySelector(targetSel) : null;
        if (!target) target = qs('.mco-pdp');
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.pageYOffset - 88;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    function shareProduct() {
      var url = story.getAttribute('data-product-url') || window.location.href;
      var title = story.getAttribute('data-product-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      if (!navigator.clipboard || !navigator.clipboard.writeText) return;
      navigator.clipboard.writeText(url).then(function () {
        qsa('[data-mco-story-share-label]', story).forEach(function (label) {
          var prev = label.getAttribute('data-label') || label.textContent;
          label.setAttribute('data-label', prev);
          label.textContent = 'Link copiado';
          window.setTimeout(function () {
            label.textContent = prev;
          }, 1600);
        });
      }).catch(function () {});
    }

    qsa('[data-mco-story-share]', story).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        shareProduct();
      });
    });

    if (waBtn) {
      waBtn.addEventListener('click', function () {
        var url = story.getAttribute('data-product-url') || window.location.href;
        var title = story.getAttribute('data-product-title') || '';
        window.open('https://wa.me/?text=' + encodeURIComponent((title + ' ' + url).trim()), '_blank', 'noopener,noreferrer');
      });
    }

    function bindZone(zone, dir) {
      if (!zone) return;
      zone.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 && e.pointerType === 'mouse') return;
        pointer = { x: e.clientX, y: e.clientY, t: Date.now(), held: false };
        window.clearTimeout(holdTimer);
        holdTimer = window.setTimeout(function () {
          if (!pointer) return;
          pointer.held = true;
          if (video && !video.paused) video.pause();
        }, 220);
      });
      zone.addEventListener('pointerup', function (e) {
        window.clearTimeout(holdTimer);
        if (!pointer) return;
        var dx = e.clientX - pointer.x;
        var dy = e.clientY - pointer.y;
        var elapsed = Date.now() - pointer.t;
        var held = pointer.held;
        pointer = null;
        if (held) {
          playCurrent();
          return;
        }
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
          show(index + (dx < 0 ? 1 : -1));
          return;
        }
        if (elapsed < 500 && Math.abs(dx) < 14 && Math.abs(dy) < 14) {
          show(index + dir);
        }
      });
      zone.addEventListener('pointercancel', function () {
        window.clearTimeout(holdTimer);
        pointer = null;
      });
    }

    bindZone(prevZone, -1);
    bindZone(nextZone, 1);

    document.addEventListener('keydown', function (e) {
      if (story.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeStory();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        show(index + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        show(index - 1);
      }
    });

    paintMute();
  }

  function initWeekCarousels() {
    qsa('[data-mco-week]').forEach(function (section) {
      if (section.getAttribute('data-mco-week-init') === '1') return;
      section.setAttribute('data-mco-week-init', '1');
      var track = qs('[data-mco-week-track]', section);
      if (!track) return;
      var prev = qs('[data-mco-week-prev]', section);
      var next = qs('[data-mco-week-next]', section);

      function step(dir) {
        var card = qs('.mco-card', track);
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 20;
        var width = card ? card.getBoundingClientRect().width + gap : Math.max(220, track.clientWidth * 0.8);
        track.scrollBy({ left: dir * width, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.target.closest('button, a, input, label')) return;
        drag = { x: e.clientX, left: track.scrollLeft, moved: false };
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4) drag.moved = true;
        track.scrollLeft = drag.left - dx;
      });
      function endDrag() {
        if (!drag) return;
        var moved = drag.moved;
        drag = null;
        track.classList.remove('is-dragging');
        if (!moved) return;
        var suppress = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          track.removeEventListener('click', suppress, true);
        };
        track.addEventListener('click', suppress, true);
        window.setTimeout(function () {
          track.removeEventListener('click', suppress, true);
        }, 50);
      }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
    });
  }

  /* Boot */
  moveDrawerChromeToBody();
  moveModalsToBody();
  ensureDrawerOverlay();
  syncWishlistUI();
  initPdpStories();
  initWeekCarousels();
  initCardSlideshow();
  initProductImageLoaders();
  initRelatedProductsSlideshow();
  initFilterDrawer();
  initNovidadesGrid();
  initCartDrawer();
  initFooter();
  initChromeScroll();
  initGridLoupe();
  initRelatedProductsGrid();
  initStickyFilterBars();
  initCartCouponBanner();
  syncEsquentaDiscount()
    .then(function () {
      return refreshCartDrawer({ skipEsquenta: true });
    })
    .catch(function () {});
  initHeroTopBanner();
  initHeroVideoDeferred();
  initFaq();
  initMenuSearch();
  initMenuLocale();
  initAttrInfoTooltips();

  /* ---- Concierge intake → WhatsApp ---- */
  function initConciergeModal() {
    var modal = qs('#mco-concierge-modal');
    var form = qs('#mco-concierge-form');
    if (!modal || !form) return;

    var badge = qs('[data-mco-concierge-badge]', modal);
    var note = qs('[data-mco-concierge-note]', modal);
    var errorBox = qs('#mco-concierge-error', modal);
    var nameInput = qs('#mco-concierge-name', modal);
    var submitBtn = qs('#mco-concierge-submit', modal);
    var tipoGroup = qs('fieldset .mco-concierge-pills', form);

    function isConciergeAvailable(date) {
      return isMilanoBusinessHours(date);
    }

    function updateConciergeStatus() {
      var available = isConciergeAvailable();
      if (badge) {
        badge.textContent = available ? 'Disponível agora' : 'Fora do horário';
        badge.classList.toggle('is-available', available);
        badge.classList.toggle('is-unavailable', !available);
      }
      if (note) {
        note.textContent = available
          ? 'Funcionamento das 10:00 às 18:00 de segunda a sexta. Resposta em poucos minutos.'
          : 'Funcionamento das 10:00 às 18:00 de segunda a sexta. Envie agora e retornamos no próximo período.';
      }
      return available;
    }

    function selectedValue(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : '';
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.hidden = !message;
      errorBox.textContent = message || '';
    }

    function buildWhatsAppMessage() {
      var name = ((nameInput && nameInput.value) || '').trim();
      var tipo = selectedValue('tipo');
      var cor = selectedValue('cor');
      var estilo = selectedValue('estilo');
      var diametro = selectedValue('diametro');
      var para = selectedValue('para');
      var productTitle = (modal.getAttribute('data-mco-product-title') || '').trim();
      var productUrl = (modal.getAttribute('data-mco-product-url') || '').trim();
      var available = isConciergeAvailable();
      var lines = [
        'Olá, me chamo ' + name + ' e gostaria de ajuda para escolher o relógio perfeito.',
        '',
      ];
      if (tipo) lines.push('• Tipo: ' + tipo);
      if (cor) lines.push('• Cor: ' + cor);
      if (estilo) lines.push('• Estilo: ' + estilo);
      if (diametro) lines.push('• Diâmetro: ' + diametro);
      if (para) lines.push('• Para: ' + para);
      if (productTitle) {
        lines.push('• Modelo de interesse: ' + productTitle);
        if (productUrl) lines.push('• Página: ' + productUrl);
      }
      lines.push('');
      lines.push(
        'Horário do envio: ' +
          new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'America/Sao_Paulo',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }).format(new Date()) +
          ' (' +
          (available ? 'Disponível' : 'Fora do horário') +
          ')'
      );
      return lines.join('\n');
    }

    function validateForm() {
      var name = ((nameInput && nameInput.value) || '').trim();
      var tipo = selectedValue('tipo');
      var ok = true;
      if (nameInput) nameInput.classList.toggle('is-invalid', !name);
      if (tipoGroup) tipoGroup.classList.toggle('is-invalid', !tipo);
      if (!name || !tipo) {
        showError('Preencha seu nome e o tipo de relógio.');
        ok = false;
      } else {
        showError('');
      }
      return ok;
    }

    updateConciergeStatus();
    modal._mcoRefreshStatus = updateConciergeStatus;
    setInterval(updateConciergeStatus, 60 * 1000);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm()) return;
      var wa = (modal.getAttribute('data-mco-wa') || '5511981159954').replace(/\D/g, '');
      var message = buildWhatsAppMessage();
      var url = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(message);
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Abrindo WhatsApp…';
      }
      window.open(url, '_blank', 'noopener,noreferrer');
      window.setTimeout(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Iniciar Atendimento';
        }
        closeModal(modal);
      }, 600);
    });

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        nameInput.classList.remove('is-invalid');
        if (selectedValue('tipo')) showError('');
      });
    }
    qsa('input[name="tipo"]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        if (tipoGroup) tipoGroup.classList.remove('is-invalid');
        if (((nameInput && nameInput.value) || '').trim()) showError('');
      });
    });

    /* Allow deselecting optional radios with a second tap */
    qsa('input[name="cor"], input[name="estilo"], input[name="diametro"], input[name="para"]', form).forEach(
      function (input) {
        input.addEventListener('click', function () {
          if (input.getAttribute('data-was-checked') === '1') {
            input.checked = false;
            input.removeAttribute('data-was-checked');
          } else {
            qsa('input[name="' + input.name + '"]', form).forEach(function (other) {
              other.removeAttribute('data-was-checked');
            });
            input.setAttribute('data-was-checked', '1');
          }
        });
      }
    );
  }

  initConciergeModal();

  /* ---- Brendha chat (bottom nav) ---- */
  var samaraTipTimer = null;
  var samaraProductIncluded = false;

  function updateSamaraOnlineDots() {
    qsa('[data-mco-samara-online]').forEach(function (dot) {
      dot.hidden = false;
    });
    var statusText = qs('[data-mco-samara-status-text]');
    if (statusText) {
      statusText.textContent = 'Responde rapidamente';
      statusText.classList.remove('is-unavailable');
    }
  }

  function hideSamaraTooltip() {
    var tip = qs('#mco-samara-tooltip');
    if (!tip) return;
    tip.hidden = true;
    if (samaraTipTimer) {
      clearTimeout(samaraTipTimer);
      samaraTipTimer = null;
    }
  }

  function scheduleSamaraTooltip(force) {
    var tip = qs('#mco-samara-tooltip');
    var msgEl = qs('[data-mco-samara-tooltip-msg]');
    var nav = qs('#mco-samara-nav');
    if (!tip || !msgEl || !nav) return;

    var lead = readBenefitsLead();
    var first = benefitsFirstName(lead);
    var lines = first
      ? [
          first + ', se precisar de ajuda, pode contar comigo.',
          first + ', qualquer dúvida, será um prazer lhe atender.',
          first + ', estou aqui se quiser uma indicação personalizada.',
        ]
      : [
          'Oi! Sou a Brendha. Se precisar de ajuda, pode contar comigo.',
          'Oi! Sou a Brendha. Qualquer dúvida, será um prazer lhe atender.',
          'Oi! Sou a Brendha. Estou aqui se quiser uma indicação personalizada.',
        ];
    msgEl.textContent = lines[Math.floor(Math.random() * lines.length)];

    function show() {
      var bottomNav = qs('#mco-bottom-nav');
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (!isDesktop && bottomNav && !bottomNav.classList.contains('is-visible')) {
        window.setTimeout(show, 600);
        return;
      }
      tip.hidden = false;
      if (samaraTipTimer) clearTimeout(samaraTipTimer);
      samaraTipTimer = window.setTimeout(hideSamaraTooltip, 3000);
    }

    window.setTimeout(show, force ? 400 : 1200);
  }

  function prepareSamaraModal() {
    var modal = qs('#mco-samara-modal');
    var nameInput = qs('#mco-samara-name');
    var messageInput = qs('#mco-samara-message');
    var chip = qs('#mco-samara-product-chip');
    var errorBox = qs('#mco-samara-error');
    if (!modal) return;

    hideSamaraTooltip();
    updateSamaraOnlineDots();
    samaraProductIncluded = false;

    var productTitle = (modal.getAttribute('data-mco-product-title') || '').trim();
    if (chip) {
      chip.setAttribute('aria-pressed', 'false');
      chip.textContent = productTitle ? 'Incluir ' + productTitle : 'Incluir produto';
    }
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    var lead = readBenefitsLead();
    if (nameInput) {
      nameInput.value = (lead && lead.name) || '';
      nameInput.classList.remove('is-invalid');
    }
    if (messageInput) {
      messageInput.value = '';
      messageInput.classList.remove('is-invalid');
    }
  }

  function initSamaraChat() {
    var modal = qs('#mco-samara-modal');
    var form = qs('#mco-samara-form');
    if (!modal || !form) return;

    var nameInput = qs('#mco-samara-name', modal);
    var messageInput = qs('#mco-samara-message', modal);
    var chip = qs('#mco-samara-product-chip', modal);
    var errorBox = qs('#mco-samara-error', modal);
    var submitBtn = qs('#mco-samara-submit', modal);
    var productTitle = (modal.getAttribute('data-mco-product-title') || '').trim();
    var productUrl = (modal.getAttribute('data-mco-product-url') || '').trim();
    var chipDefaultLabel = productTitle ? 'Incluir ' + productTitle : 'Incluir produto';

    updateSamaraOnlineDots();

    if (chip && productTitle) {
      chip.addEventListener('click', function () {
        samaraProductIncluded = !samaraProductIncluded;
        chip.setAttribute('aria-pressed', samaraProductIncluded ? 'true' : 'false');
        chip.textContent = samaraProductIncluded ? '✓ ' + productTitle : chipDefaultLabel;
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = ((nameInput && nameInput.value) || '').trim();
      var message = ((messageInput && messageInput.value) || '').trim();
      var ok = true;
      if (nameInput) nameInput.classList.toggle('is-invalid', !name);
      if (messageInput) messageInput.classList.toggle('is-invalid', !message);
      if (!name || !message) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = 'Preencha seu nome e a mensagem.';
        }
        ok = false;
      } else if (errorBox) {
        errorBox.hidden = true;
      }
      if (!ok) return;

      var lines = [message, '', '— Enviado pelo chat Brendha (Milano & Co.)'];
      if (samaraProductIncluded && productTitle) {
        lines.splice(1, 0, '', '• Produto: ' + productTitle + (productUrl ? '\n• Página: ' + productUrl : ''));
      }
      var wa = (modal.getAttribute('data-mco-wa') || '5511981159954').replace(/\D/g, '');
      var url = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(lines.join('\n'));
      if (submitBtn) {
        submitBtn.disabled = true;
      }
      window.open(url, '_blank', 'noopener,noreferrer');
      window.setTimeout(function () {
        if (submitBtn) submitBtn.disabled = false;
        closeModal(modal);
      }, 500);
    });

    /* Show tooltip anytime the bottom nav becomes visible */
    var bottomNav = qs('#mco-bottom-nav');
    if (bottomNav && typeof MutationObserver !== 'undefined') {
      var wasVisible = bottomNav.classList.contains('is-visible');
      new MutationObserver(function () {
        var visible = bottomNav.classList.contains('is-visible');
        if (visible && !wasVisible) scheduleSamaraTooltip(true);
        wasVisible = visible;
        if (!visible) hideSamaraTooltip();
      }).observe(bottomNav, { attributes: true, attributeFilter: ['class'] });
    }
    scheduleSamaraTooltip(false);
  }

  initSamaraChat();

  /* Prefill installment table if PDP cents present */
  var pdpCents = qs('[data-mco-installment-cents]');
  if (pdpCents) {
    renderInstallmentTable(parseInt(pdpCents.getAttribute('data-mco-installment-cents'), 10) / 100);
  }

  window.MCO = {
    openDrawer: openDrawer,
    closeDrawers: closeDrawers,
    openModal: openModal,
    shareCart: shareCart,
    renderInstallmentTable: renderInstallmentTable,
    readWishlist: readWishlist,
    openFilterDrawer: openFilterDrawer,
    applyNovidadesFilters: applyNovidadesFilters,
    refreshCartDrawer: refreshCartDrawer,
    prepareSamaraModal: prepareSamaraModal,
  };
})();
